export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
	ID: string;
	String: string;
	Boolean: boolean;
	Int: number;
	Float: number;
	/**
	 * An https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2 country code.
	 *
	 * e.g. 'US', 'GB'
	 */
	Country: any;
	/**
	 * Represents a date.
	 *
	 * e.g. '2006-01-02'
	 */
	Date: any;
	/**
	 * Represents a non typed JSON object.
	 *
	 * e.g. '{"foo":"bar"}'
	 */
	Json: any;
	/**
	 * A https://en.wikipedia.org/wiki/IETF_language_tag language code.
	 *
	 * e.g. 'pt-BR', 'en-US'
	 */
	Language: any;
	/** Maps an arbitrary GraphQL value to a map[string]interface{} Go type. */
	Map: any;
	/**
	 * Represents a time as a RFC3339 timestamp.
	 *
	 * e.g. '2006-01-02T15:04:05Z07:00'
	 */
	Time: any;
};

/** Represents an age certification on JustWatch. */
export type AgeCertification = {
	__typename?: 'AgeCertification';
	/** The unique id for the certificate */
	ageCertificationId: Scalars['Int'];
	/** The age certification technical name. */
	technicalName: Scalars['String'];
	/** The organization in the country responsible for the certification. */
	organization: Scalars['String'];
	/** The objectType in the country responsible for the certification(movie/show). */
	objectType: ObjectType;
};

/** The content types supported by the age certification queries. */
export enum AgeCertificationObjectType {
	/** That's a movie. */
	Movie = 'MOVIE',
	/** That's a show. */
	Show = 'SHOW',
}

/** An article is a piece of SEO comment written by an author. */
export type Article = Node & {
	__typename?: 'Article';
	/** The global node ID. */
	id: Scalars['ID'];
	/** The content of the article. */
	content: ArticleContent;
	/** The author that wrote the article. */
	author: Author;
	/** The objects linked to the article. */
	linkedObjects: Array<ArticleLinkedObject>;
};

/** An article is a piece of SEO comment written by an author. */
export type ArticleLinkedObjectsArgs = {
	priority?: Maybe<Scalars['Int']>;
};

/** The article content type. It contains the information of the article. */
export type ArticleContent = {
	__typename?: 'ArticleContent';
	/** The url of the article. */
	fullPath: Scalars['String'];
	/** The type of the article. */
	articleType: ArticleType;
	/** The title of the article. */
	title?: Maybe<Scalars['String']>;
	/** An subtitle for the article. */
	subtitle?: Maybe<Scalars['String']>;
	/** A first part of the main content of the article. */
	paragraph1?: Maybe<Scalars['String']>;
	/** A second part of the main content of the article. */
	paragraph2?: Maybe<Scalars['String']>;
	/** The synopsys of a title. */
	synopsis?: Maybe<Scalars['String']>;
	/** Includes streaming information about a title. */
	whereToWatch?: Maybe<Scalars['String']>;
	/** Info like who the actors are, what else the director worked on etc. */
	whatToKnow?: Maybe<Scalars['String']>;
	/** A timeline of news leading up to the release. */
	productionNew?: Maybe<Scalars['String']>;
	/** The created_at timestamp of the article. */
	createdAt: Scalars['Time'];
	/** the updated_at timestamp of the article. */
	updatedAt: Scalars['Time'];
};

/** The main article filter. */
export type ArticleFilter = {
	/** Keep only the articles written by the given authors. */
	authorIds?: Maybe<Array<Scalars['ID']>>;
	/** Keep only the articles having the following type. */
	articleTypes?: Maybe<Array<ArticleType>>;
};

/** An object linked to an article. */
export type ArticleLinkedObject = {
	__typename?: 'ArticleLinkedObject';
	priority: Scalars['Int'];
	node: Node;
};

/** Defines the high level type of an article. */
export enum ArticleType {
	/** An article written for a detail page. */
	TitleDetailArticle = 'TITLE_DETAIL_ARTICLE',
	/** A news article. */
	NewsArticle = 'NEWS_ARTICLE',
}

/** A connection object for the articles. */
export type ArticlesConnection = {
	__typename?: 'ArticlesConnection';
	/** The total number of items. */
	totalCount: Scalars['Int'];
	/** The edges for each of the items. */
	edges?: Maybe<Array<ArticlesEdge>>;
	/** Information for paginating this connection. */
	pageInfo: PageInfo;
};

/** An edge object for the articles */
export type ArticlesEdge = {
	__typename?: 'ArticlesEdge';
	/** A cursor used for pagination. */
	cursor: Scalars['String'];
	/** The node represented by this edge. */
	node: Article;
};

/** Audience technical names. */
export enum Audience {
	/** The user is part of the native ads audience. */
	NativeAdsExperiment = 'NATIVE_ADS_EXPERIMENT',
}

/**
 * The author type.
 * The author is a person who writes the articles.
 */
export type Author = Node & {
	__typename?: 'Author';
	/** The global node ID. */
	id: Scalars['ID'];
	/** The content of the author. */
	content: AuthorContent;
	/** The articles that are written by the author. */
	articles: ArticlesConnection;
};

/**
 * The author type.
 * The author is a person who writes the articles.
 */
export type AuthorContentArgs = {
	country: Scalars['Country'];
	language: Scalars['Language'];
};

/**
 * The author type.
 * The author is a person who writes the articles.
 */
export type AuthorArticlesArgs = {
	country: Scalars['Country'];
	first?: Scalars['Int'];
	after?: Maybe<Scalars['String']>;
	filter?: Maybe<ArticleFilter>;
};

/** The author content type. It contains the information of the author. */
export type AuthorContent = {
	__typename?: 'AuthorContent';
	/** The display name of the author. */
	clearName: Scalars['String'];
	/** The url of the author page. */
	fullPath: Scalars['String'];
	/**
	 * The image source of the author.
	 * The content URL is drectly forwarded without any modification.
	 */
	imageUrl?: Maybe<Scalars['String']>;
	/** The detailed biography of the author. */
	bio: Scalars['String'];
	/** The publications information of the author. */
	publications?: Maybe<Array<AuthorSpecificLink>>;
	/** Social media handles of the author. */
	socialHandles?: Maybe<Array<AuthorSpecificLink>>;
};

/**
 * The author specific links type.
 * It contains the name and the url of the segment.
 */
export type AuthorSpecificLink = {
	__typename?: 'AuthorSpecificLink';
	/** The name of the segment relevant to the author. */
	name: Scalars['String'];
	/** The link for the segment that can be accessed by public */
	url: Scalars['String'];
};

/** Title Leaving Soon. */
export type AvailableTo = {
	__typename?: 'AvailableTo';
	/** The related package object. */
	package: Package;
	/** The last date that the content is available in the package */
	availableToDate: Scalars['Date'];
	/** Number of days remaining for the content available in the package */
	availableCountDown: Scalars['Int'];
};

/** Title Leaving Soon. */
export type AvailableToAvailableCountDownArgs = {
	country: Scalars['Country'];
};

/** A backdrop image. */
export type Backdrop = {
	__typename?: 'Backdrop';
	/** The image url. */
	backdropUrl: Scalars['String'];
	/**
	 * The blur hash representation of the backdrop.
	 *
	 * Generated using https://github.com/woltapp/blurhash.
	 */
	backdropBlurHash?: Maybe<Scalars['String']>;
};

/** A list of image sizes supported by the scaler for backdrops. */
export enum BackdropProfile {
	/** 480x225 */
	S480 = 'S480',
	/** 640x333 */
	S640 = 'S640',
	/** 1440x750 */
	S1440 = 'S1440',
	/** 1920x900 */
	S1920 = 'S1920',
}

/** A bucket aggregation key. */
export type BucketAggregationKey = {
	__typename?: 'BucketAggregationKey';
	/** The bucket type of the aggregation denotes the date range category. */
	bucketType: NewDateRangeBucket;
};

/** A bucket package aggregation key. */
export type BucketPackageAggregationKey = {
	__typename?: 'BucketPackageAggregationKey';
	/** The bucket type of the aggregation denotes the date range category. */
	bucketType: NewDateRangeBucket;
	/** The package of the bucket. */
	package: Package;
};

/** An offer package bundle. Defined by Content. */
export type Bundle = Node & {
	__typename?: 'Bundle';
	/** The global node ID. */
	id: Scalars['ID'];
	/** The Content ID of the bundle. */
	bundleId: Scalars['Int'];
	/**
	 * A unique string identifier for the bundle.
	 *
	 * e.g. 'netflix', 'amazonprime'
	 */
	technicalName: Scalars['String'];
	/**
	 * The short version of the technical name using 3 letters.
	 *
	 * e.g. 'netflix' -> 'nfx'
	 */
	shortName: Scalars['String'];
	/**
	 * The clear human readable name of the bundle.
	 *
	 * e.g. 'Netflix', 'Amazon Prime'
	 */
	clearName: Scalars['String'];
	/**
	 * The bundle icon URL.
	 * It takes a desired size (called profile) and desired format as parameter.
	 *
	 * e.g. 's40' + 'webp' -> '/icon/207360008/s40/netflix.webp'
	 */
	icon: Scalars['String'];
	/**
	 * The blur hash representation of the icon.
	 *
	 * Generated using https://github.com/woltapp/blurhash.
	 */
	iconBlurHash?: Maybe<Scalars['String']>;
	/** The packages included in the bundle. */
	packages: Array<Package>;
	/** Indicates if the bundle was selected by the user. */
	selected: Scalars['Boolean'];
};

/** An offer package bundle. Defined by Content. */
export type BundleIconArgs = {
	profile?: Maybe<IconProfile>;
	format?: Maybe<ImageFormat>;
};

/** An offer package bundle. Defined by Content. */
export type BundlePackagesArgs = {
	country: Scalars['Country'];
	platform: Platform;
};

/** A subheading of the caught up list. */
export type CaughtUpSubheading = {
	__typename?: 'CaughtUpSubheading';
	/** The unique id of the subheading. */
	technicalName: CaughtUpSubheadingTechnicalName;
	/** The translatable of the subheading. */
	translatable: Scalars['String'];
};

/** The different subheadings possible on the edges of a caught up list. */
export enum CaughtUpSubheadingTechnicalName {
	/** The show is coming back (new episode or season). */
	Upcoming = 'UPCOMING',
	/** The show is not airing anymore. */
	Finished = 'FINISHED',
}

/** The input when clearing / emptying a custom list. */
export type ClearCustomlistInput = {
	/** The list id to clear. */
	id: Scalars['ID'];
};

/** The payload response of a custom list clearing / emptying. */
export type ClearCustomlistPayload = {
	__typename?: 'ClearCustomlistPayload';
	/** The cleared / emptied title list. */
	titleList: GenericTitleList;
};

/** A clip/trailer. */
export type Clip = {
	__typename?: 'Clip';
	/** The provider of the clip/trailer. */
	provider: ClipProvider;
	/**
	 * The external ID of the trailer/clip.
	 *
	 * e.g '1g3_CFmnU7k' for YouTube.
	 */
	externalId: Scalars['String'];
};

/** The different supported clip/trailer providers. */
export enum ClipProvider {
	/** Default one. */
	Youtube = 'YOUTUBE',
	/** We get money on these :) */
	Videobuster = 'VIDEOBUSTER',
	/** Dailymotion. */
	Dailymotion = 'DAILYMOTION',
}

/** The code we're displaying to the user. */
export type ConnectTvInput = {
	/** The code we're displaying to the user. */
	code: Scalars['String'];
};

/** The payload response of the TV account linking endpoint. */
export type ConnectTvPayload = {
	__typename?: 'ConnectTvPayload';
	/** The login id of the linked user. */
	loginId: Scalars['String'];
};

/** The input when creating new custom lists. */
export type CreateCustomlistInput = {
	/** The name of the custom list. */
	name: Scalars['String'];
	/** The visbility of the list, i.e is it public or private. */
	visibility: GenericTitleListVisibility;
};

/** The payload response of a custom list creation. */
export type CreateCustomlistPayload = {
	__typename?: 'CreateCustomlistPayload';
	/** The created title list. */
	titleList: GenericTitleList;
};

/** A credit is info about a Person involved in a Movie/Show. */
export type Credit = {
	__typename?: 'Credit';
	/**
	 * The related person.
	 *
	 * Please use the direct 'name' field instead of using the 'person' when possible to not trigger extra DB queries.
	 */
	person: Person;
	/** The Content person ID. */
	personId: Scalars['Int'];
	/** The role that the Person had in the Movie/Show. */
	role: CreditRole;
	/** The name of the Person. */
	name: Scalars['String'];
	/** The character that the Person played in the Movie/Show (ACTOR role). */
	characterName?: Maybe<Scalars['String']>;
};

/** The role that a Person had in a Movie/Show. */
export enum CreditRole {
	/** That's a director. */
	Director = 'DIRECTOR',
	/** That's an actor. */
	Actor = 'ACTOR',
}

/** The input refresh token. */
export type CustomTokenFromRefreshTokenInput = {
	/** A Firebase refresh token. */
	refreshToken: Scalars['String'];
};

/** The payload response of refresh token exchange. */
export type CustomTokenFromRefreshTokenPayload = {
	__typename?: 'CustomTokenFromRefreshTokenPayload';
	/** A Firebase custom token. */
	customToken: Scalars['String'];
};

/** A date aggregation key. */
export type DateAggregationKey = {
	__typename?: 'DateAggregationKey';
	/** The date of the bucket. */
	date: Scalars['Date'];
};

/** A Date range Title filter. . */
export type DateFilter = {
	/** The from value. */
	from?: Maybe<Scalars['Date']>;
	/** The to value. */
	to?: Maybe<Scalars['Date']>;
};

/** A date/package aggregation key. */
export type DatePackageAggregationKey = {
	__typename?: 'DatePackageAggregationKey';
	/** The date of the bucket. */
	date: Scalars['Date'];
	/** The package of the bucket. */
	package: Package;
};

/** The input when deleting a custom list. */
export type DeleteCustomlistInput = {
	/** The list id to delete. */
	id: Scalars['ID'];
};

/** The payload response of a custom list deletion. */
export type DeleteCustomlistPayload = {
	__typename?: 'DeleteCustomlistPayload';
	/** The impacted list id. */
	id: Scalars['ID'];
};

/** Represents a user device. */
export type Device = Node & {
	__typename?: 'Device';
	/** The global node ID. */
	id: Scalars['ID'];
	/** The name of the device. */
	name: Scalars['String'];
};

/** A discovery module is a list of recommended titles anchored to a certain category of content. */
export type DiscoveryModule = {
	__typename?: 'DiscoveryModule';
	/** The id of the module. */
	id: Scalars['String'];
	/** THe UUID of the discovery session. */
	discoverySessionId: Scalars['String'];
	/** A discovery module template is a description of the 'type' of the module. It's an empty module shell. */
	template: DiscoveryModuleTemplate;
	/** A bunch of metadata about how the module was generated. */
	metadata: DiscoveryModuleMetadata;
	/** Some arbitrary custom data returned for custom modules. */
	data: Scalars['Map'];
	/** The titles of the module. */
	titles: Array<MovieOrShow>;
};

export type DiscoveryModuleLayout = {
	__typename?: 'DiscoveryModuleLayout';
	/** @deprecated Use sponsoredModule instead */
	promotedModule?: Maybe<Module>;
	sponsoredModule?: Maybe<SponsoredModule>;
	spotlightModules: Array<Module>;
	mainModules: Array<Module>;
};

/** A discovery module metadata contains a bunch of info about how the module was generated. */
export type DiscoveryModuleMetadata = {
	__typename?: 'DiscoveryModuleMetadata';
	/** Information about the search that was used when calculating the module. */
	search: DiscoveryModuleSearchMetadata;
	/** Information useful when tracking on the front-end side. */
	tracking: DiscoveryModuleTrackingMetadata;
};

/** Information about the search that was used when calculating the module. */
export type DiscoveryModuleSearchMetadata = {
	__typename?: 'DiscoveryModuleSearchMetadata';
	locale?: Maybe<Scalars['String']>;
	contentTypes?: Maybe<Array<Scalars['String']>>;
	providers?: Maybe<Array<Scalars['String']>>;
	excludeProviders?: Maybe<Array<Scalars['String']>>;
	monetizationTypes?: Maybe<Array<Scalars['String']>>;
	genres?: Maybe<Array<Scalars['String']>>;
	excludeGenres?: Maybe<Array<Scalars['String']>>;
	scoringFilterTypes: Scalars['Map'];
	releaseYearFrom?: Maybe<Scalars['Int']>;
	releaseYearUntil?: Maybe<Scalars['Int']>;
	offerDateCreatedFrom?: Maybe<Scalars['String']>;
	offerDateCreatedTo?: Maybe<Scalars['String']>;
	sortBy?: Maybe<Scalars['String']>;
	personID?: Maybe<Scalars['Int']>;
};

/** A discovery module template is a description of the 'type' of the module. It's an empty module shell. */
export type DiscoveryModuleTemplate = {
	__typename?: 'DiscoveryModuleTemplate';
	/**
	 * TechnicalName uniquely identifies a module template.
	 * TechnicalName is built this way:
	 * - <namespace>
	 * - <namespace>:<subtype>
	 * - <namespace>:<subtype>:<subtype>
	 * - <namespace>:<subtype>:<subtype>:...
	 * The namespace is the first name part. It exists for every module template.
	 * Subtypes are the following name parts. They are optional. There can be 0 to n subtypes.
	 * ":" is the separator between each name part.
	 * For details on TechnicalName, namespace, subtype see:
	 * https://trello.com/c/gmMbeE37/452-consumer-api-module-template-namespace
	 */
	technicalName: Scalars['String'];
	/** The anchor is a subtype of a template in a way. e.g technicalName='MOVIES_GENRE'-> anchor='act' */
	anchor?: Maybe<Scalars['String']>;
	/** Translations for the module. */
	translations: Scalars['Map'];
};

/** Information useful when tracking on the front-end side. */
export type DiscoveryModuleTrackingMetadata = {
	__typename?: 'DiscoveryModuleTrackingMetadata';
	/** The commit of the deployed recommender. */
	recommenderCommit?: Maybe<Scalars['String']>;
	/** The deployed model version of the recommender. */
	recommenderModelIteration?: Maybe<Scalars['String']>;
	/** The level of popularity sprinkling. */
	popularitySprinkling?: Maybe<Scalars['String']>;
	/** The level of release sprinkling. */
	releaseSprinkling?: Maybe<Scalars['String']>;
	/**
	 * The tracking tokens given by the recommender are not exposed publicly in this tracking blob.
	 * It gets decorated per title at title decoration time.
	 * We cannot use `json:"-"` because we still need to marshal it and store it in the user profile api.
	 */
	recommenderTrackingTags: Scalars['Map'];
};

/** A connection object for a discovery module. */
export type DiscoveryModulesConnection = {
	__typename?: 'DiscoveryModulesConnection';
	/** The edges for each of the items. */
	edges?: Maybe<Array<DiscoveryModulesEdge>>;
	/** Indicates if a sponsored recommendation is currently active for the user. */
	activeCampaign?: Maybe<SponsoredRecommendationCampaign>;
	/** Information for paginating this connection. */
	pageInfo: PageInfo;
};

/** An edge object for a discovery module node. */
export type DiscoveryModulesEdge = {
	__typename?: 'DiscoveryModulesEdge';
	/** A cursor used for pagination. */
	cursor: Scalars['String'];
	/** The node represented by this edge. */
	node: DiscoveryModule;
};

/** A filter used to refilter dynamically last minute a set of module titles. */
export type DiscoveryModulesPostFilter = {
	/** Keep only the titles having an offer with the given packages. Short names are expected (e.g. 'nfx' for Netflix). */
	packages?: Maybe<Array<Scalars['String']>>;
};

/**
 * Ephemeral module is a list of recommended titles at the run time based on certain input
 * which inlcludes locale and user preferred mood.
 */
export type EphemeralModule = {
	__typename?: 'EphemeralModule';
	/** The list of items recommended to the user based on the Ephemeral selection filters. */
	items: Array<DiscoveryModule>;
	/** THe UUID of the discovery session. */
	currentDiscoverySessionId: Scalars['String'];
	/** The index id for the current requested session. */
	currentDiscoverySessionIndex: Scalars['Int'];
};

/** Template input used to fetch the ephemeral module. */
export type EphemeralModuleTemplateInput = {
	/** technicalName uniquely identifies a module template. */
	technicalName: Scalars['String'];
	/** The anchor is a subtype of a template in a way. e.g technicalName='MOVIES_GENRE'-> anchor='act' */
	anchor?: Maybe<Scalars['String']>;
};

/** Personalized episode aggregating user data and static Content data. */
export type Episode = MovieOrShowOrSeasonOrEpisode &
	Title &
	Node & {
		__typename?: 'Episode';
		/** The global node ID. */
		id: Scalars['ID'];
		/** The Content type of the title. */
		objectType: ObjectType;
		/** The Content ID of the title. */
		objectId: Scalars['Int'];
		/** The title data. It is localized by country and language. */
		content: EpisodeContent;
		/** The offers available on packages for the title. Depends on the country being set. */
		offers: Array<Offer>;
		/** The offer count available on packages for the title. Depends on the country being set.  */
		offerCount: Scalars['Int'];
		/**
		 * The default offer that should be used to play the title. Can be null if there are no matching offers.
		 *
		 * A default monetization type filter is applied to only keep flatrate/free offers.
		 */
		watchNowOffer?: Maybe<Offer>;
		/** The parent season of this episode. */
		season: Season;
		/** The parent show of this episode. */
		show: Show;
		/** The entry for the episode in the seenlist. */
		seenlistEntry?: Maybe<TitleListEntry>;
	};

/** Personalized episode aggregating user data and static Content data. */
export type EpisodeContentArgs = {
	country: Scalars['Country'];
	language: Scalars['Language'];
};

/** Personalized episode aggregating user data and static Content data. */
export type EpisodeOffersArgs = {
	country: Scalars['Country'];
	platform: Platform;
	filter?: OfferFilter;
};

/** Personalized episode aggregating user data and static Content data. */
export type EpisodeOfferCountArgs = {
	country: Scalars['Country'];
	platform: Platform;
	filter?: OfferFilter;
	distinctPackages?: Scalars['Boolean'];
};

/** Personalized episode aggregating user data and static Content data. */
export type EpisodeWatchNowOfferArgs = {
	country: Scalars['Country'];
	platform: Platform;
	filter?: WatchNowOfferFilter;
};

/** Unpersonalized episode data common to all the users, as defined by Content. It is localized by country and language. */
export type EpisodeContent = MovieOrShowOrSeasonOrEpisodeContent & {
	__typename?: 'EpisodeContent';
	/** The localized title of the title. Depends on the language being set. */
	title: Scalars['String'];
	/** A short description of the title. */
	shortDescription?: Maybe<Scalars['String']>;
	/** The duration of the title. For shows and seasons, it's the average runtime of an episode. */
	runtime?: Maybe<Scalars['Int']>;
	/** The year when the title was originally first released. */
	originalReleaseYear?: Maybe<Scalars['Int']>;
	/** The date when the title was originally first released. */
	originalReleaseDate?: Maybe<Scalars['Date']>;
	/** The date when the title was first released in the country. */
	localizedReleaseDate?: Maybe<Scalars['Date']>;
	/** Whether we consider the title as released or not. */
	isReleased: Scalars['Boolean'];
	/** The title upcoming releases on streaming or cinema. Sorted by release date. */
	upcomingReleases: Array<UpcomingRelease>;
	/** The season number. */
	seasonNumber: Scalars['Int'];
	/** The episode number. */
	episodeNumber: Scalars['Int'];
};

/** Unpersonalized episode data common to all the users, as defined by Content. It is localized by country and language. */
export type EpisodeContentUpcomingReleasesArgs = {
	releaseTypes?: Maybe<Array<ReleaseType>>;
	packages?: Maybe<Array<Scalars['String']>>;
};

/** The payload response of a legacy JWT token exchange. */
export type ExchangeLegacyJwtPayload = {
	__typename?: 'ExchangeLegacyJwtPayload';
	/** The login id of the user. */
	loginId: Scalars['Boolean'];
	/** The firebase JWT. */
	firebaseJwt: Scalars['String'];
};

/** A set of IDs of the title on external platforms. */
export type ExternalIds = {
	__typename?: 'ExternalIds';
	/** The IMDB ID. */
	imdbId?: Maybe<Scalars['String']>;
	/** The TMDB ID. */
	tmdbId?: Maybe<Scalars['String']>;
};

/** An float range filter. Filter is disabled is null or zero. */
export type FloatFilter = {
	/** The min value. */
	min?: Maybe<Scalars['Float']>;
	/** The max value. */
	max?: Maybe<Scalars['Float']>;
};

/** An entry in the user followed list. */
export type FollowedListEntry = {
	__typename?: 'FollowedListEntry';
	/** The time at which the entry was created. */
	createdAt: Scalars['Time'];
	/** The override name of the title list, given by the follower of the list. */
	name: Scalars['String'];
};

/** A generic title list. */
export type GenericTitleList = Node & {
	__typename?: 'GenericTitleList';
	/** The global node ID. */
	id: Scalars['ID'];
	/** Indicates the type of the list. Usually tied to the source of the list (made by users or internal JW lists). */
	type: GenericTitleListType;
	/** The visibility of a generic title list. Impacts who's allowed to access the list. */
	visibility: GenericTitleListVisibility;
	/** Flag indicating if the list is owned by the current user. */
	ownedByUser: Scalars['Boolean'];
	/** The name of the title list, given by the creator of the list. */
	name: Scalars['String'];
	/** The entry for the title list in the followedlist. */
	followedlistEntry?: Maybe<FollowedListEntry>;
	/** The titles inside of the title list. */
	titles: GenericTitleListConnection;
};

/** A generic title list. */
export type GenericTitleListTitlesArgs = {
	country: Scalars['Country'];
	first?: Scalars['Int'];
	after?: Maybe<Scalars['String']>;
	filter?: Maybe<TitleFilter>;
	sortBy?: GenericTitleListSorting;
	sortRandomSeed?: Scalars['Int'];
};

/** A connection object for the external title list titles. */
export type GenericTitleListConnection = {
	__typename?: 'GenericTitleListConnection';
	/** The total number of items. */
	totalCount: Scalars['Int'];
	/** The edges for each of the items. */
	edges?: Maybe<Array<GenericTitleListEdge>>;
	/** Information for paginating this connection. */
	pageInfo: PageInfo;
};

/** An edge object for the external title list titles. */
export type GenericTitleListEdge = {
	__typename?: 'GenericTitleListEdge';
	/** A cursor used for pagination. */
	cursor: Scalars['String'];
	/** The node represented by this edge. */
	node: MovieOrShow;
};

/** The field/info to order titles by. */
export enum GenericTitleListSorting {
	/** Sorted by JW popularity score. */
	Popular = 'POPULAR',
	/** Sorted by JW trending score. */
	Trending = 'TRENDING',
	/** Sorted randomly, based on the provided randomSeed. */
	Random = 'RANDOM',
	/** Sorted by title. */
	Alphabetical = 'ALPHABETICAL',
	/** Sorted by release year. */
	ReleaseYear = 'RELEASE_YEAR',
	/** Sorted by TMDB popularity. */
	TmdbPopularity = 'TMDB_POPULARITY',
	/** Sorted by IMDB score. */
	ImdbScore = 'IMDB_SCORE',
	/** Sorted by runtime. */
	Runtime = 'RUNTIME',
	/** Not reordered. We follow the natural order of the list. */
	Natural = 'NATURAL',
}

/** The type of a GenericTitleList object. Usually tied to the source of the list. */
export enum GenericTitleListType {
	/** Stored in the user profile api as 'user title lists' and maintained by users. */
	UserList = 'USER_LIST',
	/** Stored in the user profile api as 'technical user title lists' and maintained in the Audience Builder. */
	TechnicalUserList = 'TECHNICAL_USER_LIST',
	/** That's a list also used in the campaign department, stored in the user profile api as 'internal title lists' and maintained in the NCMS. */
	PermanentAudienceList = 'PERMANENT_AUDIENCE_LIST',
}

/** The visibility of a generic title list. */
export enum GenericTitleListVisibility {
	/** Visible and searchable by everyone. */
	Public = 'PUBLIC',
	/** Visible by everyone with a direct link. */
	Unlisted = 'UNLISTED',
	/** Only visible to the owner. */
	Private = 'PRIVATE',
}

/** A connection object for generic title lists. */
export type GenericTitleListsConnection = {
	__typename?: 'GenericTitleListsConnection';
	/** The total number of items. */
	totalCount: Scalars['Int'];
	/** The edges for each of the items. */
	edges?: Maybe<Array<GenericTitleListsEdge>>;
	/** Information for paginating this connection. */
	pageInfo: PageInfo;
};

/** An edge object for generic title lists. */
export type GenericTitleListsEdge = {
	__typename?: 'GenericTitleListsEdge';
	/** A cursor used for pagination. */
	cursor: Scalars['String'];
	/** The node represented by this edge. */
	node: GenericTitleList;
};

/** The content types supported by the age certification queries. */
export enum GenericTitleListsType {
	/** The custom lists made by the user. */
	CustomLists = 'CUSTOM_LISTS',
	/** The lists followed by the user. */
	FollowedLists = 'FOLLOWED_LISTS',
}

/** A title genre. Defined by Content. */
export type Genre = Node & {
	__typename?: 'Genre';
	/** The global node ID. */
	id: Scalars['ID'];
	/**
	 * A unique string identifier for the genre.
	 *
	 * e.g. 'action', 'comedy'
	 */
	technicalName: Scalars['String'];
	/**
	 * The short version of the technical name using 3 letters.
	 *
	 * e.g. 'action' -> 'act'
	 */
	shortName: Scalars['String'];
	/**
	 * The short label for the genre, to be used in the URL (helps SEO)
	 *
	 * e.g. 'action' -> 'action-and-adventure'
	 */
	slug: Scalars['String'];
	/**
	 * The name of the genre to be displayed in the required language (for display)
	 *
	 * e.g. 'Action & Adventure'
	 */
	translation: Scalars['String'];
};

/** A title genre. Defined by Content. */
export type GenreSlugArgs = {
	language: Scalars['Language'];
};

/** A title genre. Defined by Content. */
export type GenreTranslationArgs = {
	language: Scalars['Language'];
};

/** The potential existing IDs of the user. */
export type GetNewDeviceIdInput = {
	/**
	 * A list of known IDs of the device.
	 *
	 * e.g. A Google device ID, etc...
	 */
	ids: Array<Scalars['String']>;
	/** The user indicated that they would like to not be tracked. */
	doNotTrack: Scalars['Boolean'];
};

/** The payload response of the TV JWT polling. */
export type GetNewDeviceIdPayload = {
	__typename?: 'GetNewDeviceIdPayload';
	/** The found Device ID for the user. */
	deviceId: Scalars['String'];
	/** The IP of the HTTP request sender. */
	ip: Scalars['String'];
	/** The locale in which the IP of the sender is located. */
	locale?: Maybe<LocaleState>;
};

/** The payload response of TV code request. */
export type GetTvCodePayload = {
	__typename?: 'GetTvCodePayload';
	/** The code to display to the user. */
	code: Scalars['String'];
	/** A security UUID to store. */
	uuid: Scalars['String'];
};

/** A href lang tag. Defined by Content. */
export type HrefLangTag = {
	__typename?: 'HrefLangTag';
	/**
	 * The locale attached to the tag.
	 *
	 * e.g. 'en_US'
	 */
	locale: Scalars['String'];
	/**
	 * The href lang attached to the tag.
	 *
	 * e.g. 'en-US'
	 */
	hrefLang: Scalars['String'];
	/** The full path of the URL variation in the given locale. */
	href: Scalars['String'];
};

/** The release state of the locale. */
export enum I18nState {
	/** Fully released. */
	Active = 'ACTIVE',
	/** On its way to be released. */
	Staging = 'STAGING',
}

/** A list of image sizes supported by the scaler for icons. */
export enum IconProfile {
	/** 20x20 */
	S20 = 'S20',
	/** 25x25 */
	S25 = 'S25',
	/** 40x40 */
	S40 = 'S40',
	/** 50x50 */
	S50 = 'S50',
	/** 100x100 */
	S100 = 'S100',
	/** 166x166 */
	S166 = 'S166',
	/** 332x332 */
	S332 = 'S332',
}

/** A list of image formats supported by the scaler. */
export enum ImageFormat {
	/** That's for .png */
	Png = 'PNG',
	/** That's for .jpg */
	Jpg = 'JPG',
	/** That's for .webp */
	Webp = 'WEBP',
}

/** The input when importing an IMDB list. */
export type ImportImdbListInput = {
	/**
	 * The URL of the IMDB list
	 * example: https://www.imdb.com/user/ur163600461/watchlist
	 */
	url: Scalars['String'];
	/** Type of target list */
	targetType: TargetType;
	/** The target list id (when TargetType is e.g. EXISTING_CUSTOMLIST) */
	targetList?: Maybe<Scalars['ID']>;
};

/** The payload response of an IMDB import. */
export type ImportImdbListPayload = {
	__typename?: 'ImportIMDBListPayload';
	/** The target list */
	importedList: GenericTitleList;
	/** The IMDB IDs that we could not find in our database */
	notFoundIds: Array<Scalars['String']>;
};

/** An integer range filter. Filter is disabled is null or zero. */
export type IntFilter = {
	/** The min value. */
	min?: Maybe<Scalars['Int']>;
	/** The max value. */
	max?: Maybe<Scalars['Int']>;
};

/** The different types of issues to report on the platform. */
export enum IssueReportType {
	/** Wrong link takes to different content */
	Mismatch = 'MISMATCH',
	/** The content is not available. */
	TitleNotAvailable = 'TITLE_NOT_AVAILABLE',
	/** The content is available elsewhere but not mentioned on the platform. */
	MissingOffer = 'MISSING_OFFER',
	/** The mentioned offer is wrong/ incorrect. */
	WrongOffer = 'WRONG_OFFER',
	/** The mentioned movie/show information is wrong. */
	WrongInfo = 'WRONG_INFO',
	/** Any bug observed in the current section/page. */
	Bug = 'BUG',
	/** Any other issue that is not listed above. */
	Other = 'OTHER',
}

/** The user tracking consent. */
export type JwConsents = {
	__typename?: 'JWConsents';
	/** That's for Google. */
	google?: Maybe<Scalars['Boolean']>;
	/** That's for Twitter. */
	twitter?: Maybe<Scalars['Boolean']>;
	/** That's for Facebook. */
	facebook?: Maybe<Scalars['Boolean']>;
	/** That's for TikTok. */
	tiktok?: Maybe<Scalars['Boolean']>;
	/** That's for everything else. */
	allother?: Maybe<Scalars['Boolean']>;
	/** The user agreed to the JW terms and conditions. */
	termsAndConditions?: Maybe<Scalars['Boolean']>;
	/** The user agreed to receive emails from JW. */
	emails?: Maybe<Scalars['Boolean']>;
};

/** The user tracking consent. */
export type JwConsentsInput = {
	/** That's for Google. */
	google?: Maybe<Scalars['Boolean']>;
	/** That's for Twitter. */
	twitter?: Maybe<Scalars['Boolean']>;
	/** That's for Facebook. */
	facebook?: Maybe<Scalars['Boolean']>;
	/** That's for everything else. */
	allother?: Maybe<Scalars['Boolean']>;
	/** The user agreed to receive emails from JW. */
	emails?: Maybe<Scalars['Boolean']>;
};

/** Represents a language on JustWatch. */
export type LanguageState = {
	__typename?: 'LanguageState';
	/** The ISO language. */
	language: Scalars['Language'];
	/** If the language is enabled or in staging mode. */
	i18nState: I18nState;
};

/** Represents a locale on JustWatch. */
export type LocaleState = {
	__typename?: 'LocaleState';
	/** The ISO locale. */
	fullLocale: Scalars['String'];
	/** The country linked to the locale. */
	country: Scalars['Country'];
	/** If the locale is enabled or in staging mode. */
	i18nState: I18nState;
	/** The locale namespace used to build the website URLs. e.g. 'us' -> '/us/popular' */
	exposedUrlPart: Scalars['String'];
	/** The currency ISO code. e.g. 'EUR' */
	currency: Scalars['String'];
	/** The currency symbol if we know it. Fallsback to ISO currency. */
	currencySymbol: Scalars['String'];
	/** The translated country name. */
	countryName?: Maybe<Scalars['String']>;
	/** The timezone (long name) e.g. 'Europe/Berlin' */
	timezone: Scalars['String'];
	/** The timezone offset of locale. */
	timezoneOffset: Scalars['Int'];
	/** The timezone (short name) e.g. 'CET' */
	timezoneAbbreviation: Scalars['String'];
};

/** Represents a locale on JustWatch. */
export type LocaleStateCountryNameArgs = {
	language: Scalars['Language'];
};

/** A list of image sizes supported by the scaler for logos. */
export enum LogoProfile {
	/** 200x80 */
	S200 = 'S200',
	/** 400x160 */
	S400 = 'S400',
}

/** A discovery module is a module made of a template, a content, translations and a score. */
export type Module = {
	__typename?: 'Module';
	template: ModuleTemplate;
	content?: Maybe<ModuleContent>;
	/** Translations for the module. */
	translations: ModuleTranslations;
	fomoScore: Scalars['Int'];
};

/** A discovery module is a module made of a template, a content, translations and a score. */
export type ModuleTranslationsArgs = {
	language: Scalars['Language'];
};

export type ModuleContent = ModuleContentTitles | ModuleContentTitlesPerPackage | ModuleContentTitlesRelatedToTitle;

export type ModuleContentPackageTitles = {
	__typename?: 'ModuleContentPackageTitles';
	package: Package;
	titles: Array<ModuleContentTitleEdge>;
	/** The total number of titles. */
	totalCount: Scalars['Int'];
};

export type ModuleContentTitleEdge = {
	__typename?: 'ModuleContentTitleEdge';
	trend?: Maybe<ModuleContentTitleTrend>;
	/** The offer (or one of the offers) that triggered the node to be returned. */
	triggerOffer?: Maybe<Offer>;
	node: MovieOrShowOrSeason;
};

/** The evolution of a title in a list. */
export enum ModuleContentTitleTrend {
	/** The title is stable. */
	Stable = 'STABLE',
	/** The title is going up. */
	Up = 'UP',
	/** The title is going down. */
	Down = 'DOWN',
}

export type ModuleContentTitles = {
	__typename?: 'ModuleContentTitles';
	titles: Array<ModuleContentTitleEdge>;
	/** The total number of titles. */
	totalCount: Scalars['Int'];
};

export type ModuleContentTitlesPerPackage = {
	__typename?: 'ModuleContentTitlesPerPackage';
	packages: Array<ModuleContentPackageTitles>;
};

export type ModuleContentTitlesRelatedToTitle = {
	__typename?: 'ModuleContentTitlesRelatedToTitle';
	titles: Array<ModuleContentTitleEdge>;
	relatedTo: ModuleContentTitleEdge;
	/** The total number of titles. */
	totalCount: Scalars['Int'];
};

/** The different content types of discovery modules. */
export enum ModuleContentType {
	/** The module contains a flat list of titles. */
	Titles = 'TITLES',
	/** The module contains lists of titles, grouped by package. */
	TitlesPerPackage = 'TITLES_PER_PACKAGE',
	/** The module contains lists of titles, related to a title. */
	TitlesRelatedToTitle = 'TITLES_RELATED_TO_TITLE',
}

/** The different promoted content modes. */
export enum ModulePromotionMode {
	/** Returns the 'MAIN_WATCHED_BY_SIMILAR_USERS' module in the sponsored slot. */
	SponsoredRecommendation = 'SPONSORED_RECOMMENDATION',
}

/** A discovery module template is a description of the 'type' of the module. It's an empty module shell. */
export type ModuleTemplate = {
	__typename?: 'ModuleTemplate';
	/** TechnicalName uniquely identifies a module template. */
	technicalName: Scalars['String'];
	/** The content type of the module. */
	contentType: ModuleContentType;
	/** The anchor is a subtype of a template in a way. e.g technicalName='MOVIES_GENRE'-> anchor='act' */
	anchor?: Maybe<Scalars['String']>;
};

/** Traslated/localized module informations. */
export type ModuleTranslations = {
	__typename?: 'ModuleTranslations';
	/** The title of the module. */
	title?: Maybe<Scalars['String']>;
	/** Additional badge on the module. */
	badge?: Maybe<Scalars['String']>;
};

/** The way an offer of monetized. */
export enum MonetizationType {
	/** Offer is buyable. */
	Buy = 'BUY',
	/** Offer is rentable. */
	Rent = 'RENT',
	/** Offer is watchable if subscribed to the package for a flat fee. */
	Flatrate = 'FLATRATE',
	/** Offer is watchable if subscribed to the package for a flat fee, but also needs an extra payment. */
	FlatrateAndBuy = 'FLATRATE_AND_BUY',
	/** Offer is watchable for free but with ads. */
	Ads = 'ADS',
	/** Offer is watchable for free. */
	Free = 'FREE',
	/** Offer is watchable at the cinema. */
	Cinema = 'CINEMA',
}

/** Personalized movie aggregating user data and static Content data. */
export type Movie = MovieOrShow &
	MovieOrSeason &
	MovieOrShowOrSeason &
	MovieOrShowOrSeasonOrEpisode &
	Title &
	Node & {
		__typename?: 'Movie';
		/**
		 * The global node ID of the title. For titles, it is defined by Content and made from object type + object ID.
		 *
		 * e.g. 'tm21' -> 'movie' + 21, 'tss11' -> 'show_season' + 11
		 */
		id: Scalars['ID'];
		/** The Content type of the title. */
		objectType: ObjectType;
		/** The Content ID of the title. */
		objectId: Scalars['Int'];
		/** The date where the title is leaving the users provider. */
		availableTo: Array<AvailableTo>;
		/** The title data. It is localized by country and language. */
		content: MovieContent;
		/** The offers available on packages for the title. Depends on the country being set. */
		offers: Array<Offer>;
		/** The offer count available on packages for the title. Depends on the country being set.  */
		offerCount: Scalars['Int'];
		/** The offers promoted for this title. Depends on the country being set. */
		promotedOffers: Array<Offer>;
		/** The bundles promoted for this title. Calculated from the offers. Depends on the country being set. */
		promotedBundles: Array<PromotedBundleEdge>;
		/**
		 * The default offer that should be used to play the title. Can be null if there are no matching offers.
		 *
		 * A default monetization type filter is applied to only keep flatrate/free offers.
		 */
		watchNowOffer?: Maybe<Offer>;
		/** The entry for the movie in the watchlist. */
		watchlistEntry?: Maybe<TitleListEntry>;
		/** The entry for the movie in the likelist. */
		likelistEntry?: Maybe<TitleListEntry>;
		/** The entry for the movie in the dislikelist. */
		dislikelistEntry?: Maybe<TitleListEntry>;
		/** The entries in the user's customlists. */
		customlistEntries: Array<TitleListEntry>;
		/**
		 * A list of similar titles. Not specific to the user, returning the same for all users.
		 * @deprecated Use the V2 :)
		 */
		similarTitles: Array<MovieOrShow>;
		/** A list of similar titles. Not specific to the user, returning the same for all users. */
		similarTitlesV2: SimilarTitlesConnection;
		/** A list of permanent audience IDs the title is part of. */
		permanentAudiences: Array<Scalars['String']>;
		/** The popularity rank and its trend popularity behaviour for the given title and its neighbouring titles. */
		popularityRank: PopularityRank;
		/** The entry for the movie in the seenlist. */
		seenlistEntry?: Maybe<TitleListEntry>;
	};

/** Personalized movie aggregating user data and static Content data. */
export type MovieAvailableToArgs = {
	country: Scalars['Country'];
	platform: Platform;
	packages?: Maybe<Array<Scalars['String']>>;
};

/** Personalized movie aggregating user data and static Content data. */
export type MovieContentArgs = {
	country: Scalars['Country'];
	language: Scalars['Language'];
};

/** Personalized movie aggregating user data and static Content data. */
export type MovieOffersArgs = {
	country: Scalars['Country'];
	platform: Platform;
	filter?: OfferFilter;
};

/** Personalized movie aggregating user data and static Content data. */
export type MovieOfferCountArgs = {
	country: Scalars['Country'];
	platform: Platform;
	filter?: OfferFilter;
	distinctPackages?: Scalars['Boolean'];
};

/** Personalized movie aggregating user data and static Content data. */
export type MoviePromotedOffersArgs = {
	country: Scalars['Country'];
	platform: Platform;
	filter?: OfferFilter;
};

/** Personalized movie aggregating user data and static Content data. */
export type MoviePromotedBundlesArgs = {
	country: Scalars['Country'];
	platform: Platform;
	filter?: OfferFilter;
};

/** Personalized movie aggregating user data and static Content data. */
export type MovieWatchNowOfferArgs = {
	country: Scalars['Country'];
	platform: Platform;
	filter?: WatchNowOfferFilter;
};

/** Personalized movie aggregating user data and static Content data. */
export type MovieSimilarTitlesArgs = {
	country: Scalars['Country'];
	filter?: Maybe<TitleFilter>;
	limit?: Scalars['Int'];
};

/** Personalized movie aggregating user data and static Content data. */
export type MovieSimilarTitlesV2Args = {
	country: Scalars['Country'];
	filter?: Maybe<TitleFilter>;
	first?: Scalars['Int'];
	allowSponsoredRecommendations?: Maybe<SponsoredRecommendationsInput>;
};

/** Personalized movie aggregating user data and static Content data. */
export type MoviePopularityRankArgs = {
	country: Scalars['Country'];
	previousTitles?: Scalars['Int'];
	nextTitles?: Scalars['Int'];
	category?: PopularityRankTypes;
};

/** Unpersonalized movie data common to all the users, as defined by Content. It is localized by country and language. */
export type MovieContent = MovieOrShowContent &
	MovieOrShowOrSeasonContent &
	MovieOrSeasonContent &
	MovieOrShowOrSeasonOrEpisodeContent & {
		__typename?: 'MovieContent';
		/** The original title of the title. */
		originalTitle: Scalars['String'];
		/** The localized title of the title. Depends on the language being set. */
		title: Scalars['String'];
		/** A short description of the title. */
		shortDescription?: Maybe<Scalars['String']>;
		/** The duration of the title. For shows and seasons, it's the average runtime of an episode. */
		runtime?: Maybe<Scalars['Int']>;
		/** The year when the title was originally first released. */
		originalReleaseYear?: Maybe<Scalars['Int']>;
		/** The date when the title was originally first released. */
		originalReleaseDate?: Maybe<Scalars['Date']>;
		/** The date when the title was first released in the country. */
		localizedReleaseDate?: Maybe<Scalars['Date']>;
		/** Whether we consider the title as released or not. */
		isReleased: Scalars['Boolean'];
		/** The title upcoming releases on streaming or cinema. Sorted by release date. */
		upcomingReleases: Array<UpcomingRelease>;
		/**
		 * The localized website detail page URL of the title. Depends on the country being set.
		 *
		 * e.g. '/us/movie/batman-the-dark-knight'
		 */
		fullPath: Scalars['String'];
		/** The related genre objects. */
		genres: Array<Genre>;
		/** The trailers/clips attached to the title. */
		clips: Array<Clip>;
		/** The countries where the title was produced. */
		productionCountries: Array<Scalars['Country']>;
		/**
		 * The localized poster URL. Depends on the country and language being set.
		 * It takes a desired size (called profile) and desired format as parameter.
		 *
		 * e.g. 's166' + 'webp' -> '/poster/8711516/s166/memento.webp'
		 */
		posterUrl?: Maybe<Scalars['String']>;
		/**
		 * The blur hash representation of the poster.
		 *
		 * Generated using https://github.com/woltapp/blurhash.
		 */
		posterBlurHash?: Maybe<Scalars['String']>;
		/**
		 * A list of backdrops. It takes a desired size (called profile) and desired format as parameter.
		 *
		 * e.g. 's1440' + 'webp' -> '/backdrop/8711516/s1440/Spider-Man-Homecoming.webp'
		 */
		backdrops: Array<Backdrop>;
		/** All the scorings/ratings of the title. */
		scoring: Scoring;
		/** All the IDs of the title on external platforms. */
		externalIds: ExternalIds;
		/** The credits of the title. The 'personId' filter can be used to check if a certain person was involved in the title. */
		credits: Array<Credit>;
		/** The age rating. e.g. PG-13 for movies, TV-PG for shows in the US */
		ageCertification?: Maybe<Scalars['String']>;
	};

/** Unpersonalized movie data common to all the users, as defined by Content. It is localized by country and language. */
export type MovieContentUpcomingReleasesArgs = {
	releaseTypes?: Maybe<Array<ReleaseType>>;
	packages?: Maybe<Array<Scalars['String']>>;
};

/** Unpersonalized movie data common to all the users, as defined by Content. It is localized by country and language. */
export type MovieContentClipsArgs = {
	providers?: Maybe<Array<ClipProvider>>;
};

/** Unpersonalized movie data common to all the users, as defined by Content. It is localized by country and language. */
export type MovieContentPosterUrlArgs = {
	profile?: Maybe<PosterProfile>;
	format?: Maybe<ImageFormat>;
};

/** Unpersonalized movie data common to all the users, as defined by Content. It is localized by country and language. */
export type MovieContentBackdropsArgs = {
	profile?: Maybe<BackdropProfile>;
	format?: Maybe<ImageFormat>;
};

/** Unpersonalized movie data common to all the users, as defined by Content. It is localized by country and language. */
export type MovieContentCreditsArgs = {
	first?: Maybe<Scalars['Int']>;
	role?: Maybe<CreditRole>;
	personId?: Maybe<Scalars['Int']>;
};

/**
 * Personalized title aggregating user data and static Content data.
 *
 * This interface contains the fields that are common between the movie and season titles.
 */
export type MovieOrSeason = {
	/**
	 * The global node ID of the title. For titles, it is defined by Content and made from object type + object ID.
	 *
	 * e.g. 'tm21' -> 'movie' + 21, 'tss11' -> 'show_season' + 11
	 */
	id: Scalars['ID'];
	/** The Content type of the title. */
	objectType: ObjectType;
	/** The Content ID of the title. */
	objectId: Scalars['Int'];
	/** The date where the title is leaving the users provider. */
	availableTo: Array<AvailableTo>;
	/** The title data. It is localized by country and language. */
	content: MovieOrSeasonContent;
	/** The offers available on packages for the title. Depends on the country being set. */
	offers: Array<Offer>;
	/** The offer count available on packages for the title. Depends on the country being set.  */
	offerCount: Scalars['Int'];
	/** The offers promoted for this title. Depends on the country being set. */
	promotedOffers: Array<Offer>;
	/** The bundles promoted for this title. Calculated from the offers. Depends on the country being set. */
	promotedBundles: Array<PromotedBundleEdge>;
	/**
	 * The default offer that should be used to play the title. Can be null if there are no matching offers.
	 *
	 * A default monetization type filter is applied to only keep flatrate/free offers.
	 */
	watchNowOffer?: Maybe<Offer>;
};

/**
 * Personalized title aggregating user data and static Content data.
 *
 * This interface contains the fields that are common between the movie and season titles.
 */
export type MovieOrSeasonAvailableToArgs = {
	country: Scalars['Country'];
	platform: Platform;
	packages?: Maybe<Array<Scalars['String']>>;
};

/**
 * Personalized title aggregating user data and static Content data.
 *
 * This interface contains the fields that are common between the movie and season titles.
 */
export type MovieOrSeasonContentArgs = {
	country: Scalars['Country'];
	language: Scalars['Language'];
};

/**
 * Personalized title aggregating user data and static Content data.
 *
 * This interface contains the fields that are common between the movie and season titles.
 */
export type MovieOrSeasonOffersArgs = {
	country: Scalars['Country'];
	platform: Platform;
	filter?: OfferFilter;
};

/**
 * Personalized title aggregating user data and static Content data.
 *
 * This interface contains the fields that are common between the movie and season titles.
 */
export type MovieOrSeasonOfferCountArgs = {
	country: Scalars['Country'];
	platform: Platform;
	filter?: OfferFilter;
	distinctPackages?: Scalars['Boolean'];
};

/**
 * Personalized title aggregating user data and static Content data.
 *
 * This interface contains the fields that are common between the movie and season titles.
 */
export type MovieOrSeasonPromotedOffersArgs = {
	country: Scalars['Country'];
	platform: Platform;
	filter?: OfferFilter;
};

/**
 * Personalized title aggregating user data and static Content data.
 *
 * This interface contains the fields that are common between the movie and season titles.
 */
export type MovieOrSeasonPromotedBundlesArgs = {
	country: Scalars['Country'];
	platform: Platform;
	filter?: OfferFilter;
};

/**
 * Personalized title aggregating user data and static Content data.
 *
 * This interface contains the fields that are common between the movie and season titles.
 */
export type MovieOrSeasonWatchNowOfferArgs = {
	country: Scalars['Country'];
	platform: Platform;
	filter?: WatchNowOfferFilter;
};

/**
 * Unpersonalized title data common to all the users, as defined by Content. It is localized by country and language.
 *
 * This interface contains the fields that are common between the movie and season title contents.
 */
export type MovieOrSeasonContent = {
	/** The localized title of the title. Depends on the language being set. */
	title: Scalars['String'];
	/** A short description of the title. */
	shortDescription?: Maybe<Scalars['String']>;
	/** The duration of the title. For shows and seasons, it's the average runtime of an episode. */
	runtime?: Maybe<Scalars['Int']>;
	/** The year when the title was originally first released. */
	originalReleaseYear?: Maybe<Scalars['Int']>;
	/** The date when the title was originally first released. */
	originalReleaseDate?: Maybe<Scalars['Date']>;
	/** The date when the title was first released in the country. */
	localizedReleaseDate?: Maybe<Scalars['Date']>;
	/** Whether we consider the title as released or not. */
	isReleased: Scalars['Boolean'];
	/** The title upcoming releases on streaming or cinema. Sorted by release date. */
	upcomingReleases: Array<UpcomingRelease>;
	/**
	 * The localized website detail page URL of the title. Depends on the country being set.
	 *
	 * e.g. '/us/movie/batman-the-dark-knight'
	 */
	fullPath: Scalars['String'];
	/** The related genre objects. */
	genres: Array<Genre>;
	/** The trailers/clips attached to the title. */
	clips: Array<Clip>;
	/**
	 * The localized poster URL. Depends on the country and language being set.
	 * It takes a desired size (called profile) and desired format as parameter.
	 *
	 * e.g. 's166' + 'webp' -> '/poster/8711516/s166/memento.webp'
	 */
	posterUrl?: Maybe<Scalars['String']>;
	/**
	 * The blur hash representation of the poster.
	 *
	 * Generated using https://github.com/woltapp/blurhash.
	 */
	posterBlurHash?: Maybe<Scalars['String']>;
	/**
	 * A list of backdrops. It takes a desired size (called profile) and desired format as parameter.
	 *
	 * e.g. 's1440' + 'webp' -> '/backdrop/8711516/s1440/Spider-Man-Homecoming.webp'
	 */
	backdrops: Array<Backdrop>;
	/** All the scorings/ratings of the title. */
	scoring: Scoring;
	/** All the IDs of the title on external platforms. */
	externalIds: ExternalIds;
};

/**
 * Unpersonalized title data common to all the users, as defined by Content. It is localized by country and language.
 *
 * This interface contains the fields that are common between the movie and season title contents.
 */
export type MovieOrSeasonContentUpcomingReleasesArgs = {
	releaseTypes?: Maybe<Array<ReleaseType>>;
	packages?: Maybe<Array<Scalars['String']>>;
};

/**
 * Unpersonalized title data common to all the users, as defined by Content. It is localized by country and language.
 *
 * This interface contains the fields that are common between the movie and season title contents.
 */
export type MovieOrSeasonContentClipsArgs = {
	providers?: Maybe<Array<ClipProvider>>;
};

/**
 * Unpersonalized title data common to all the users, as defined by Content. It is localized by country and language.
 *
 * This interface contains the fields that are common between the movie and season title contents.
 */
export type MovieOrSeasonContentPosterUrlArgs = {
	profile?: Maybe<PosterProfile>;
	format?: Maybe<ImageFormat>;
};

/**
 * Unpersonalized title data common to all the users, as defined by Content. It is localized by country and language.
 *
 * This interface contains the fields that are common between the movie and season title contents.
 */
export type MovieOrSeasonContentBackdropsArgs = {
	profile?: Maybe<BackdropProfile>;
	format?: Maybe<ImageFormat>;
};

/**
 * Personalized title aggregating user data and static Content data.
 *
 * This interface contains the fields that are common between the movie and show titles.
 */
export type MovieOrShow = {
	/**
	 * The global node ID of the title. For titles, it is defined by Content and made from object type + object ID.
	 *
	 * e.g. 'tm21' -> 'movie' + 21, 'tss11' -> 'show_season' + 11
	 */
	id: Scalars['ID'];
	/** The Content type of the title. */
	objectType: ObjectType;
	/** The Content ID of the title. */
	objectId: Scalars['Int'];
	/** The date where the title is leaving the users provider. */
	availableTo: Array<AvailableTo>;
	/** The title data. It is localized by country and language. */
	content: MovieOrShowContent;
	/** The offers available on packages for the title. Depends on the country being set. */
	offers: Array<Offer>;
	/** The offer count available on packages for the title. Depends on the country being set.  */
	offerCount: Scalars['Int'];
	/** The offers promoted for this title. Depends on the country being set. */
	promotedOffers: Array<Offer>;
	/** The bundles promoted for this title. Calculated from the offers. Depends on the country being set. */
	promotedBundles: Array<PromotedBundleEdge>;
	/**
	 * The default offer that should be used to play the title. Can be null if there are no matching offers.
	 *
	 * A default monetization type filter is applied to only keep flatrate/free offers.
	 */
	watchNowOffer?: Maybe<Offer>;
	/** The entry for the movie in the watchlist. */
	watchlistEntry?: Maybe<TitleListEntry>;
	/** The entry for the movie in the likelist. */
	likelistEntry?: Maybe<TitleListEntry>;
	/** The entry for the movie in the dislikelist. */
	dislikelistEntry?: Maybe<TitleListEntry>;
	/** The entries in the user's customlists. */
	customlistEntries: Array<TitleListEntry>;
	/**
	 * A list of similar titles. Not specific to the user, returning the same for all users.
	 * @deprecated Use the V2 :)
	 */
	similarTitles: Array<MovieOrShow>;
	/** A list of similar titles. Not specific to the user, returning the same for all users. */
	similarTitlesV2: SimilarTitlesConnection;
	/** A list of permanent audience IDs the title is part of. */
	permanentAudiences: Array<Scalars['String']>;
	/** The popularity rank and its trend popularity behaviour for the given title and its neighbouring titles. */
	popularityRank: PopularityRank;
};

/**
 * Personalized title aggregating user data and static Content data.
 *
 * This interface contains the fields that are common between the movie and show titles.
 */
export type MovieOrShowAvailableToArgs = {
	country: Scalars['Country'];
	platform: Platform;
	packages?: Maybe<Array<Scalars['String']>>;
};

/**
 * Personalized title aggregating user data and static Content data.
 *
 * This interface contains the fields that are common between the movie and show titles.
 */
export type MovieOrShowContentArgs = {
	country: Scalars['Country'];
	language: Scalars['Language'];
};

/**
 * Personalized title aggregating user data and static Content data.
 *
 * This interface contains the fields that are common between the movie and show titles.
 */
export type MovieOrShowOffersArgs = {
	country: Scalars['Country'];
	platform: Platform;
	filter?: OfferFilter;
};

/**
 * Personalized title aggregating user data and static Content data.
 *
 * This interface contains the fields that are common between the movie and show titles.
 */
export type MovieOrShowOfferCountArgs = {
	country: Scalars['Country'];
	platform: Platform;
	filter?: OfferFilter;
	distinctPackages?: Scalars['Boolean'];
};

/**
 * Personalized title aggregating user data and static Content data.
 *
 * This interface contains the fields that are common between the movie and show titles.
 */
export type MovieOrShowPromotedOffersArgs = {
	country: Scalars['Country'];
	platform: Platform;
	filter?: OfferFilter;
};

/**
 * Personalized title aggregating user data and static Content data.
 *
 * This interface contains the fields that are common between the movie and show titles.
 */
export type MovieOrShowPromotedBundlesArgs = {
	country: Scalars['Country'];
	platform: Platform;
	filter?: OfferFilter;
};

/**
 * Personalized title aggregating user data and static Content data.
 *
 * This interface contains the fields that are common between the movie and show titles.
 */
export type MovieOrShowWatchNowOfferArgs = {
	country: Scalars['Country'];
	platform: Platform;
	filter?: WatchNowOfferFilter;
};

/**
 * Personalized title aggregating user data and static Content data.
 *
 * This interface contains the fields that are common between the movie and show titles.
 */
export type MovieOrShowSimilarTitlesArgs = {
	country: Scalars['Country'];
	filter?: Maybe<TitleFilter>;
	limit?: Scalars['Int'];
};

/**
 * Personalized title aggregating user data and static Content data.
 *
 * This interface contains the fields that are common between the movie and show titles.
 */
export type MovieOrShowSimilarTitlesV2Args = {
	country: Scalars['Country'];
	filter?: Maybe<TitleFilter>;
	first?: Scalars['Int'];
	allowSponsoredRecommendations?: Maybe<SponsoredRecommendationsInput>;
};

/**
 * Personalized title aggregating user data and static Content data.
 *
 * This interface contains the fields that are common between the movie and show titles.
 */
export type MovieOrShowPopularityRankArgs = {
	country: Scalars['Country'];
	previousTitles?: Scalars['Int'];
	nextTitles?: Scalars['Int'];
	category?: PopularityRankTypes;
};

/**
 * Unpersonalized title data common to all the users, as defined by Content. It is localized by country and language.
 *
 * This interface contains the fields that are common between the movie and show title contents.
 */
export type MovieOrShowContent = {
	/** The original title of the title. */
	originalTitle: Scalars['String'];
	/** The localized title of the title. Depends on the language being set. */
	title: Scalars['String'];
	/** A short description of the title. */
	shortDescription?: Maybe<Scalars['String']>;
	/** The duration of the title. For shows and seasons, it's the average runtime of an episode. */
	runtime?: Maybe<Scalars['Int']>;
	/** The year when the title was originally first released. */
	originalReleaseYear?: Maybe<Scalars['Int']>;
	/** The date when the title was originally first released. */
	originalReleaseDate?: Maybe<Scalars['Date']>;
	/** The date when the title was first released in the country. */
	localizedReleaseDate?: Maybe<Scalars['Date']>;
	/** Whether we consider the title as released or not. */
	isReleased: Scalars['Boolean'];
	/** The title upcoming releases on streaming or cinema. Sorted by release date. */
	upcomingReleases: Array<UpcomingRelease>;
	/**
	 * The localized website detail page URL of the title. Depends on the country being set.
	 *
	 * e.g. '/us/movie/batman-the-dark-knight'
	 */
	fullPath: Scalars['String'];
	/** The related genre objects. */
	genres: Array<Genre>;
	/** The trailers/clips attached to the title. */
	clips: Array<Clip>;
	/** The countries where the title was produced. */
	productionCountries: Array<Scalars['Country']>;
	/**
	 * The localized poster URL. Depends on the country and language being set.
	 * It takes a desired size (called profile) and desired format as parameter.
	 *
	 * e.g. 's166' + 'webp' -> '/poster/8711516/s166/memento.webp'
	 */
	posterUrl?: Maybe<Scalars['String']>;
	/**
	 * The blur hash representation of the poster.
	 *
	 * Generated using https://github.com/woltapp/blurhash.
	 */
	posterBlurHash?: Maybe<Scalars['String']>;
	/**
	 * A list of backdrops. It takes a desired size (called profile) and desired format as parameter.
	 *
	 * e.g. 's1440' + 'webp' -> '/backdrop/8711516/s1440/Spider-Man-Homecoming.webp'
	 */
	backdrops: Array<Backdrop>;
	/** All the scorings/ratings of the title. */
	scoring: Scoring;
	/** All the IDs of the title on external platforms. */
	externalIds: ExternalIds;
	/** The credits of the title. The 'personId' filter can be used to check if a certain person was involved in the title. */
	credits: Array<Credit>;
	/** The age rating. e.g. PG-13 for movies, TV-PG for shows in the US */
	ageCertification?: Maybe<Scalars['String']>;
};

/**
 * Unpersonalized title data common to all the users, as defined by Content. It is localized by country and language.
 *
 * This interface contains the fields that are common between the movie and show title contents.
 */
export type MovieOrShowContentUpcomingReleasesArgs = {
	releaseTypes?: Maybe<Array<ReleaseType>>;
	packages?: Maybe<Array<Scalars['String']>>;
};

/**
 * Unpersonalized title data common to all the users, as defined by Content. It is localized by country and language.
 *
 * This interface contains the fields that are common between the movie and show title contents.
 */
export type MovieOrShowContentClipsArgs = {
	providers?: Maybe<Array<ClipProvider>>;
};

/**
 * Unpersonalized title data common to all the users, as defined by Content. It is localized by country and language.
 *
 * This interface contains the fields that are common between the movie and show title contents.
 */
export type MovieOrShowContentPosterUrlArgs = {
	profile?: Maybe<PosterProfile>;
	format?: Maybe<ImageFormat>;
};

/**
 * Unpersonalized title data common to all the users, as defined by Content. It is localized by country and language.
 *
 * This interface contains the fields that are common between the movie and show title contents.
 */
export type MovieOrShowContentBackdropsArgs = {
	profile?: Maybe<BackdropProfile>;
	format?: Maybe<ImageFormat>;
};

/**
 * Unpersonalized title data common to all the users, as defined by Content. It is localized by country and language.
 *
 * This interface contains the fields that are common between the movie and show title contents.
 */
export type MovieOrShowContentCreditsArgs = {
	first?: Maybe<Scalars['Int']>;
	role?: Maybe<CreditRole>;
	personId?: Maybe<Scalars['Int']>;
};

/**
 * Personalized title aggregating user data and static Content data.
 *
 * This interface contains the fields that are common between the movie, show and season titles.
 */
export type MovieOrShowOrSeason = {
	/**
	 * The global node ID of the title. For titles, it is defined by Content and made from object type + object ID.
	 *
	 * e.g. 'tm21' -> 'movie' + 21, 'tss11' -> 'show_season' + 11
	 */
	id: Scalars['ID'];
	/** The Content type of the title. */
	objectType: ObjectType;
	/** The Content ID of the title. */
	objectId: Scalars['Int'];
	/** The date where the title is leaving the users provider. */
	availableTo: Array<AvailableTo>;
	/** The title data. It is localized by country and language. */
	content: MovieOrShowOrSeasonContent;
	/** The offers available on packages for the title. Depends on the country being set. */
	offers: Array<Offer>;
	/** The offer count available on packages for the title. Depends on the country being set.  */
	offerCount: Scalars['Int'];
	/** The offers promoted for this title. Depends on the country being set. */
	promotedOffers: Array<Offer>;
	/** The bundles promoted for this title. Calculated from the offers. Depends on the country being set. */
	promotedBundles: Array<PromotedBundleEdge>;
	/** The popularity rank and its trend popularity behaviour for the given title and its neighbouring titles. */
	popularityRank: PopularityRank;
	/**
	 * The default offer that should be used to play the title. Can be null if there are no matching offers.
	 *
	 * A default monetization type filter is applied to only keep flatrate/free offers.
	 */
	watchNowOffer?: Maybe<Offer>;
};

/**
 * Personalized title aggregating user data and static Content data.
 *
 * This interface contains the fields that are common between the movie, show and season titles.
 */
export type MovieOrShowOrSeasonAvailableToArgs = {
	country: Scalars['Country'];
	platform: Platform;
	packages?: Maybe<Array<Scalars['String']>>;
};

/**
 * Personalized title aggregating user data and static Content data.
 *
 * This interface contains the fields that are common between the movie, show and season titles.
 */
export type MovieOrShowOrSeasonContentArgs = {
	country: Scalars['Country'];
	language: Scalars['Language'];
};

/**
 * Personalized title aggregating user data and static Content data.
 *
 * This interface contains the fields that are common between the movie, show and season titles.
 */
export type MovieOrShowOrSeasonOffersArgs = {
	country: Scalars['Country'];
	platform: Platform;
	filter?: OfferFilter;
};

/**
 * Personalized title aggregating user data and static Content data.
 *
 * This interface contains the fields that are common between the movie, show and season titles.
 */
export type MovieOrShowOrSeasonOfferCountArgs = {
	country: Scalars['Country'];
	platform: Platform;
	filter?: OfferFilter;
	distinctPackages?: Scalars['Boolean'];
};

/**
 * Personalized title aggregating user data and static Content data.
 *
 * This interface contains the fields that are common between the movie, show and season titles.
 */
export type MovieOrShowOrSeasonPromotedOffersArgs = {
	country: Scalars['Country'];
	platform: Platform;
	filter?: OfferFilter;
};

/**
 * Personalized title aggregating user data and static Content data.
 *
 * This interface contains the fields that are common between the movie, show and season titles.
 */
export type MovieOrShowOrSeasonPromotedBundlesArgs = {
	country: Scalars['Country'];
	platform: Platform;
	filter?: OfferFilter;
};

/**
 * Personalized title aggregating user data and static Content data.
 *
 * This interface contains the fields that are common between the movie, show and season titles.
 */
export type MovieOrShowOrSeasonPopularityRankArgs = {
	country: Scalars['Country'];
	previousTitles?: Scalars['Int'];
	nextTitles?: Scalars['Int'];
	category?: PopularityRankTypes;
};

/**
 * Personalized title aggregating user data and static Content data.
 *
 * This interface contains the fields that are common between the movie, show and season titles.
 */
export type MovieOrShowOrSeasonWatchNowOfferArgs = {
	country: Scalars['Country'];
	platform: Platform;
	filter?: WatchNowOfferFilter;
};

/**
 * Unpersonalized title data common to all the users, as defined by Content. It is localized by country and language.
 *
 * This interface contains the fields that are common between the movie, show and season title contents.
 */
export type MovieOrShowOrSeasonContent = {
	/** The localized title of the title. Depends on the language being set. */
	title: Scalars['String'];
	/** A short description of the title. */
	shortDescription?: Maybe<Scalars['String']>;
	/** The duration of the title. For shows and seasons, it's the average runtime of an episode. */
	runtime?: Maybe<Scalars['Int']>;
	/** The year when the title was originally first released. */
	originalReleaseYear?: Maybe<Scalars['Int']>;
	/** The date when the title was originally first released. */
	originalReleaseDate?: Maybe<Scalars['Date']>;
	/** The date when the title was first released in the country. */
	localizedReleaseDate?: Maybe<Scalars['Date']>;
	/** Whether we consider the title as released or not. */
	isReleased: Scalars['Boolean'];
	/** The title upcoming releases on streaming or cinema. Sorted by release date. */
	upcomingReleases: Array<UpcomingRelease>;
	/**
	 * The localized website detail page URL of the title. Depends on the country being set.
	 *
	 * e.g. '/us/movie/batman-the-dark-knight'
	 */
	fullPath: Scalars['String'];
	/** The related genre objects. */
	genres: Array<Genre>;
	/** The trailers/clips attached to the title. */
	clips: Array<Clip>;
	/**
	 * The localized poster URL. Depends on the country and language being set.
	 * It takes a desired size (called profile) and desired format as parameter.
	 *
	 * e.g. 's166' + 'webp' -> '/poster/8711516/s166/memento.webp'
	 */
	posterUrl?: Maybe<Scalars['String']>;
	/**
	 * The blur hash representation of the poster.
	 *
	 * Generated using https://github.com/woltapp/blurhash.
	 */
	posterBlurHash?: Maybe<Scalars['String']>;
	/**
	 * A list of backdrops. It takes a desired size (called profile) and desired format as parameter.
	 *
	 * e.g. 's1440' + 'webp' -> '/backdrop/8711516/s1440/Spider-Man-Homecoming.webp'
	 */
	backdrops: Array<Backdrop>;
	/** All the scorings/ratings of the title. */
	scoring: Scoring;
	/** All the IDs of the title on external platforms. */
	externalIds: ExternalIds;
};

/**
 * Unpersonalized title data common to all the users, as defined by Content. It is localized by country and language.
 *
 * This interface contains the fields that are common between the movie, show and season title contents.
 */
export type MovieOrShowOrSeasonContentUpcomingReleasesArgs = {
	releaseTypes?: Maybe<Array<ReleaseType>>;
	packages?: Maybe<Array<Scalars['String']>>;
};

/**
 * Unpersonalized title data common to all the users, as defined by Content. It is localized by country and language.
 *
 * This interface contains the fields that are common between the movie, show and season title contents.
 */
export type MovieOrShowOrSeasonContentClipsArgs = {
	providers?: Maybe<Array<ClipProvider>>;
};

/**
 * Unpersonalized title data common to all the users, as defined by Content. It is localized by country and language.
 *
 * This interface contains the fields that are common between the movie, show and season title contents.
 */
export type MovieOrShowOrSeasonContentPosterUrlArgs = {
	profile?: Maybe<PosterProfile>;
	format?: Maybe<ImageFormat>;
};

/**
 * Unpersonalized title data common to all the users, as defined by Content. It is localized by country and language.
 *
 * This interface contains the fields that are common between the movie, show and season title contents.
 */
export type MovieOrShowOrSeasonContentBackdropsArgs = {
	profile?: Maybe<BackdropProfile>;
	format?: Maybe<ImageFormat>;
};

/**
 * Personalized title aggregating user data and static Content data.
 *
 * This interface contains the fields that are common between the movie, show, season and episode titles.
 */
export type MovieOrShowOrSeasonOrEpisode = {
	/**
	 * The global node ID of the title. For titles, it is defined by Content and made from object type + object ID.
	 *
	 * e.g. 'tm21' -> 'movie' + 21, 'tss11' -> 'show_season' + 11
	 */
	id: Scalars['ID'];
	/** The Content type of the title. */
	objectType: ObjectType;
	/** The Content ID of the title. */
	objectId: Scalars['Int'];
	/** The title data. It is localized by country and language. */
	content: MovieOrShowOrSeasonOrEpisodeContent;
	/** The offers available on packages for the title. Depends on the country being set. */
	offers: Array<Offer>;
	/** The offer count available on packages for the title. Depends on the country being set.  */
	offerCount: Scalars['Int'];
	/**
	 * The default offer that should be used to play the title. Can be null if there are no matching offers.
	 *
	 * A default monetization type filter is applied to only keep flatrate/free offers.
	 */
	watchNowOffer?: Maybe<Offer>;
};

/**
 * Personalized title aggregating user data and static Content data.
 *
 * This interface contains the fields that are common between the movie, show, season and episode titles.
 */
export type MovieOrShowOrSeasonOrEpisodeContentArgs = {
	country: Scalars['Country'];
	language: Scalars['Language'];
};

/**
 * Personalized title aggregating user data and static Content data.
 *
 * This interface contains the fields that are common between the movie, show, season and episode titles.
 */
export type MovieOrShowOrSeasonOrEpisodeOffersArgs = {
	country: Scalars['Country'];
	platform: Platform;
	filter?: OfferFilter;
};

/**
 * Personalized title aggregating user data and static Content data.
 *
 * This interface contains the fields that are common between the movie, show, season and episode titles.
 */
export type MovieOrShowOrSeasonOrEpisodeOfferCountArgs = {
	country: Scalars['Country'];
	platform: Platform;
	filter?: OfferFilter;
	distinctPackages?: Scalars['Boolean'];
};

/**
 * Personalized title aggregating user data and static Content data.
 *
 * This interface contains the fields that are common between the movie, show, season and episode titles.
 */
export type MovieOrShowOrSeasonOrEpisodeWatchNowOfferArgs = {
	country: Scalars['Country'];
	platform: Platform;
	filter?: WatchNowOfferFilter;
};

/**
 * Unpersonalized title data common to all the users, as defined by Content. It is localized by country and language.
 *
 * This interface contains the fields that are common between the movie, show, season and episode title contents.
 */
export type MovieOrShowOrSeasonOrEpisodeContent = {
	/** The localized title of the title. Depends on the language being set. */
	title: Scalars['String'];
	/** A short description of the title. */
	shortDescription?: Maybe<Scalars['String']>;
	/** The duration of the title. For shows and seasons, it's the average runtime of an episode. */
	runtime?: Maybe<Scalars['Int']>;
	/** The year when the title was originally first released. */
	originalReleaseYear?: Maybe<Scalars['Int']>;
	/** The date when the title was originally first released. */
	originalReleaseDate?: Maybe<Scalars['Date']>;
	/** The date when the title was first released in the country. */
	localizedReleaseDate?: Maybe<Scalars['Date']>;
	/** Whether we consider the title as released or not. */
	isReleased: Scalars['Boolean'];
	/** The title upcoming releases on streaming or cinema. Sorted by release date. */
	upcomingReleases: Array<UpcomingRelease>;
};

/**
 * Unpersonalized title data common to all the users, as defined by Content. It is localized by country and language.
 *
 * This interface contains the fields that are common between the movie, show, season and episode title contents.
 */
export type MovieOrShowOrSeasonOrEpisodeContentUpcomingReleasesArgs = {
	releaseTypes?: Maybe<Array<ReleaseType>>;
	packages?: Maybe<Array<Scalars['String']>>;
};

/** A multi step sport event. */
export type MultiStepSportEvent = SportEventV2 &
	SportTitle &
	Node & {
		__typename?: 'MultiStepSportEvent';
		/** The global node ID. */
		id: Scalars['ID'];
		/** The Content type of the title. */
		objectType: ObjectType;
		/** The Content ID of the title. */
		objectId: Scalars['Int'];
		/** The sport of the event. */
		sport: SportType;
		/** The sport event data. It is localized by language. */
		content: MultiStepSportEventContent;
		/** The offers for the sport event. */
		offers: Array<SportOffer>;
		/** The offer count available on packages for the event. Depends on the country being set.  */
		offerCount: Scalars['Int'];
		/** The default offer that should be used to play the event. Can be null if there are no matching offers. */
		watchNowOffer?: Maybe<SportOffer>;
		/** The competition the event belongs to. */
		competition?: Maybe<SportCompetitionV2>;
		/** The entry for the sport event in the my sport list. */
		mysportlistEntry?: Maybe<TitleListEntry>;
		/** The parent racing events */
		parent?: Maybe<MultiStepSportEvent>;
		/** The closest happening event or the most interesting one. */
		activeChild?: Maybe<MultiStepSportEvent>;
		/** A list of children formula racing events. */
		children: Array<MultiStepSportEvent>;
	};

/** A multi step sport event. */
export type MultiStepSportEventContentArgs = {
	country: Scalars['Country'];
	language: Scalars['Language'];
};

/** A multi step sport event. */
export type MultiStepSportEventOffersArgs = {
	country: Scalars['Country'];
	platform: Platform;
	filter?: SportOfferFilter;
};

/** A multi step sport event. */
export type MultiStepSportEventOfferCountArgs = {
	country: Scalars['Country'];
	platform: Platform;
	filter?: SportOfferFilter;
};

/** A multi step sport event. */
export type MultiStepSportEventWatchNowOfferArgs = {
	country: Scalars['Country'];
	platform: Platform;
	filter?: WatchNowSportOfferFilter;
};

/** A multi step event information. */
export type MultiStepSportEventContent = SportEventContentV2 & {
	__typename?: 'MultiStepSportEventContent';
	/** A localized name for the match */
	name: Scalars['String'];
	/** General status of the event */
	status: SportEventStatus;
	/** When the event starts */
	startAt: Scalars['Time'];
	/** When the event ends */
	endAt?: Maybe<Scalars['Time']>;
	/** The venue where the event was held */
	venue?: Maybe<SportVenue>;
	/** The competition season during which the event took place */
	season?: Maybe<SportSeason>;
	/**
	 * A list of backdrops. It takes a desired size (called profile) and desired format as parameter.
	 *
	 * e.g. 's1440' + 'webp' -> '/backdrop/8711516/s1440/Spider-Man-Homecoming.webp'
	 */
	backdrops: Array<Backdrop>;
	/**
	 * The localized website detail page URL of the sport event. Depends on the country being set.
	 *
	 * e.g. '/de/fussball/La-Liga/FC-Barcelona-Real-Madrid-2021-2022'
	 */
	fullPath?: Maybe<Scalars['String']>;
	/** The stage of the competition the event is in. */
	competitionStage: SportCompetitionStageV2;
};

/** A multi step event information. */
export type MultiStepSportEventContentBackdropsArgs = {
	profile?: Maybe<BackdropProfile>;
	format?: Maybe<ImageFormat>;
};

/** The mutation root of JustWatch's GraphQL interface. */
export type Mutation = {
	__typename?: 'Mutation';
	/**
	 * Fetches and return a new Device ID for the device.
	 *
	 * On mobile, we also pass the Google/Apple device identifier so the Device ID of users can stay the same across reinstalls.
	 */
	getNewDeviceId: GetNewDeviceIdPayload;
	/** Exchanges a Firebase refresh token for Firebase custom token. Used to migrate between the old mobile app and the React Native app. */
	customTokenFromRefreshToken: CustomTokenFromRefreshTokenPayload;
	/** Used at sign up. Registers a new Firebase user into our internal ID system. A login ID gets assigned to the user. We need to pass a Firebase JWT in the Authorization header. */
	registerNewUser: RegisterPayload;
	/** Registers/tracks a login operation into our internal ID system. */
	registerLogin: RegisterPayload;
	/** Registers/tracks a logout operation into our internal ID system. */
	registerLogout: RegisterPayload;
	/** The first step of the TV login flow. We return a code to display to the user. */
	getTvCode: GetTvCodePayload;
	/** The second step of the TV login flow. The TV should poll this endpoint, waiting for a Firebase JWT to be returned. */
	pollForTvJwt: PollForTvJwtPayload;
	/** The third step of the TV login flow. While the TV is polling, a logged in user can use this endpoint to link their account to the TV. */
	connectTv: ConnectTvPayload;
	/** Sets or unsets a movie/show in the watchlist. */
	setInWatchlist: SetInTitleListPayload;
	/** Sets or unsets a movie/show in the likelist. */
	setInLikelist: SetInTitleListPayload;
	/** Sets or unsets a movie/show in the dislikelist. */
	setInDislikelist: SetInTitleListPayload;
	/** Sets or unsets a movie/show/season/episode in the seenlist. */
	setInSeenlist: SetInSeenlistPayload;
	/** Sets or unsets a batch of movie/show/season/episode in the seenlist. */
	setInSeenlistBatch: SetInSeenlistBatchPayload;
	/** Sets or unsets a sport_event in the sportlist. */
	setInMysportlist: SetInMysportlistPayload;
	/** Creates a new customlist with a given name. */
	createCustomlist: CreateCustomlistPayload;
	/** Deletes a customlist by ID. */
	deleteCustomlist: DeleteCustomlistPayload;
	/** Clears / empties a customlist by ID. */
	clearCustomlist: ClearCustomlistPayload;
	/** Imports an IMDB List to a list */
	importIMDBList: ImportImdbListPayload;
	/** Sets or unsets a title id in the given customlist. */
	setInCustomlist: SetInTitleListPayload;
	/** Sets or unsets a list id in the followed list. */
	setInFollowedList: SetInFollowedListPayload;
	/** Allows partial updates of the user settings. */
	updateSettings: UpdateSettingsPayload;
	/** Sets or unsets a package in the user settings. */
	setPackage: UpdateSettingsPayload;
	/** Sets or unsets a bundle in the user settings. */
	setBundle: UpdateSettingsPayload;
	/** Sends a title play event to devices listening on the 'playTitleReceived' subscription. */
	playTitle: PlayTitlePayload;
	/** Creates a Stripe checkout session */
	createStripeCheckoutSession: StripeCheckoutSessionPayload;
	/** Reset the taste survey preference information. */
	tasteSurveyReset: TasteSurveyResetPayload;
	/** Cancels an active stripe subscription for the user */
	cancelStripeSubscription: CancelStripeSubscriptionPayload;
	/** To report the feedback or issue about the specific content in the platform. */
	reportFeedback: ReportFeedbackPayload;
};

/** The mutation root of JustWatch's GraphQL interface. */
export type MutationGetNewDeviceIdArgs = {
	input: GetNewDeviceIdInput;
};

/** The mutation root of JustWatch's GraphQL interface. */
export type MutationCustomTokenFromRefreshTokenArgs = {
	input: CustomTokenFromRefreshTokenInput;
};

/** The mutation root of JustWatch's GraphQL interface. */
export type MutationPollForTvJwtArgs = {
	input: PollForTvJwtInput;
};

/** The mutation root of JustWatch's GraphQL interface. */
export type MutationConnectTvArgs = {
	input: ConnectTvInput;
};

/** The mutation root of JustWatch's GraphQL interface. */
export type MutationSetInWatchlistArgs = {
	input: SetInTitleListInput;
};

/** The mutation root of JustWatch's GraphQL interface. */
export type MutationSetInLikelistArgs = {
	input: SetInTitleListInput;
};

/** The mutation root of JustWatch's GraphQL interface. */
export type MutationSetInDislikelistArgs = {
	input: SetInTitleListInput;
};

/** The mutation root of JustWatch's GraphQL interface. */
export type MutationSetInSeenlistArgs = {
	input: SetInSeenlistInput;
};

/** The mutation root of JustWatch's GraphQL interface. */
export type MutationSetInSeenlistBatchArgs = {
	input: SetInSeenlistBatchInput;
};

/** The mutation root of JustWatch's GraphQL interface. */
export type MutationSetInMysportlistArgs = {
	input: SetInTitleListInput;
};

/** The mutation root of JustWatch's GraphQL interface. */
export type MutationCreateCustomlistArgs = {
	input: CreateCustomlistInput;
};

/** The mutation root of JustWatch's GraphQL interface. */
export type MutationDeleteCustomlistArgs = {
	input: DeleteCustomlistInput;
};

/** The mutation root of JustWatch's GraphQL interface. */
export type MutationClearCustomlistArgs = {
	input: ClearCustomlistInput;
};

/** The mutation root of JustWatch's GraphQL interface. */
export type MutationImportImdbListArgs = {
	input: ImportImdbListInput;
};

/** The mutation root of JustWatch's GraphQL interface. */
export type MutationSetInCustomlistArgs = {
	input: SetInCustomlistInput;
};

/** The mutation root of JustWatch's GraphQL interface. */
export type MutationSetInFollowedListArgs = {
	input: SetInFollowedListInput;
};

/** The mutation root of JustWatch's GraphQL interface. */
export type MutationUpdateSettingsArgs = {
	input: UpdateSettingsInput;
};

/** The mutation root of JustWatch's GraphQL interface. */
export type MutationSetPackageArgs = {
	input: SetPackageInput;
};

/** The mutation root of JustWatch's GraphQL interface. */
export type MutationSetBundleArgs = {
	input: SetBundleInput;
};

/** The mutation root of JustWatch's GraphQL interface. */
export type MutationPlayTitleArgs = {
	input: PlayTitleInput;
};

/** The mutation root of JustWatch's GraphQL interface. */
export type MutationCreateStripeCheckoutSessionArgs = {
	input: StripeCheckoutSessionInput;
};

/** The mutation root of JustWatch's GraphQL interface. */
export type MutationReportFeedbackArgs = {
	input: ReportFeedbackInput;
};

/** A connection object for the mySport event buckets. */
export type MySportEventBucketsConnection = {
	__typename?: 'MySportEventBucketsConnection';
	/** The edges for each of the buckets. */
	edges?: Maybe<Array<SportEventBucketsEdgeV2>>;
	/** Information for paginating this connection. */
	pageInfo: PageInfo;
};

/** A connection object for the mySport events. */
export type MySportEventsConnection = {
	__typename?: 'MySportEventsConnection';
	/** The total number of items. */
	totalCount: Scalars['Int'];
	/** The edges for each of the items. */
	edges?: Maybe<Array<SportEventsEdgeV2>>;
	/** Information for paginating this connection. */
	pageInfo: PageInfo;
};

/** The different ways for the new timeline upcoming & leaving soon buckets. Instead of a particular date, grouped by ranges. */
export enum NewDateRangeBucket {
	/** Titles for today. */
	Today = 'TODAY',
	/** Titles for tomorrow. i.e, next 24 hours content. */
	Tomorrow = 'TOMORROW',
	/** Titles belong to the next 7 days, excluding tomorrow content. */
	Next_7Days = 'NEXT_7_DAYS',
	/** Titles for next 30 days excluding the next 7 days content. */
	Next_30Days = 'NEXT_30_DAYS',
}

/** The different types of new page filter */
export enum NewPageType {
	/** New offer content that are currently available in the pacakages. */
	New = 'NEW',
	/** Upcoming content to be added to the package based on the offer available date. */
	Upcoming = 'UPCOMING',
	/** Contents that are leaving soon from the package */
	LeavingSoon = 'LEAVING_SOON',
	/** On-sale content on the selected packages which considers only buy/rent packages into account. */
	PriceDrop = 'PRICE_DROP',
}

/** The different ways of aggregating the new timeline results. */
export enum NewTitleAggregation {
	/** We aggregate by date/package. */
	DatePackage = 'DATE_PACKAGE',
	/** We only aggregate by date. */
	Date = 'DATE',
}

/** A list of the possible aggregation keys being returned, depending on the aggregation type. */
export type NewTitleAggregationKey =
	| DatePackageAggregationKey
	| DateAggregationKey
	| BucketPackageAggregationKey
	| BucketAggregationKey;

/** A connection object for the new title buckets. */
export type NewTitleBucketsConnection = {
	__typename?: 'NewTitleBucketsConnection';
	/** The edges for each of the buckets. */
	edges?: Maybe<Array<NewTitleBucketsEdge>>;
	/** Information for paginating this connection. */
	pageInfo: PageInfo;
};

/** An edge object for the new title buckets. */
export type NewTitleBucketsEdge = {
	__typename?: 'NewTitleBucketsEdge';
	/** A cursor used for pagination. */
	cursor: Scalars['String'];
	/** The bucket aggregation key. */
	key: NewTitleAggregationKey;
	/** The node represented by this edge. */
	node: NewTitlesConnection;
};

/** A connection object for the new titles. */
export type NewTitlesConnection = {
	__typename?: 'NewTitlesConnection';
	/** The total number of items. */
	totalCount: Scalars['Int'];
	/** Indicates if a sponsored recommendation is currently active for the user. */
	activeCampaign?: Maybe<SponsoredRecommendationCampaign>;
	/** The edges for each of the items. */
	edges?: Maybe<Array<NewTitlesEdge>>;
	/** Information for paginating this connection. */
	pageInfo: PageInfo;
};

/** An edge object for the new titles. */
export type NewTitlesEdge = {
	__typename?: 'NewTitlesEdge';
	/** A cursor used for pagination. */
	cursor: Scalars['String'];
	/** The new offer (or one of the new offers) that triggered the node to be there. */
	newOffer?: Maybe<Offer>;
	/** The node represented by this edge. */
	node: MovieOrSeason;
};

/** An edge object for the new titles. */
export type NewTitlesEdgeNewOfferArgs = {
	platform: Platform;
};

/** An object with an ID. */
export type Node = {
	/** The global node ID. */
	id: Scalars['ID'];
};

/** The type of a Content object. */
export enum ObjectType {
	/** That's a movie. */
	Movie = 'MOVIE',
	/** That's a show. */
	Show = 'SHOW',
	/** That's a season. */
	ShowSeason = 'SHOW_SEASON',
	/** That's an episode. */
	ShowEpisode = 'SHOW_EPISODE',
	/** That's a person. */
	Person = 'PERSON',
	/** That's a static page on the website. */
	Page = 'PAGE',
	/** That's a sport. */
	Sport = 'SPORT',
	/** That's a sport event. */
	SportEvent = 'SPORT_EVENT',
	/** That's a sport competition. */
	SportCompetition = 'SPORT_COMPETITION',
	/** That's a sport competitor. */
	SportCompetitor = 'SPORT_COMPETITOR',
	/** That's an author. */
	Author = 'AUTHOR',
}

/**
 * Defines the offering of a package for a certain Content title. Unique key is (jwEntityID, country, packageId, monetizationType, presentationType).
 *
 * e.g. 'The Matrix', 'US', 'Netflix', 'Flatrate', '4K'
 */
export type Offer = Node & {
	__typename?: 'Offer';
	/** The global node ID. */
	id: Scalars['ID'];
	/** The parent title of the offer. */
	title: MovieOrShowOrSeasonOrEpisode;
	/** The nature of the offer. */
	type: OfferType;
	/** The related package object. */
	package: Package;
	/** The monetization of the offer. */
	monetizationType: MonetizationType;
	/** The presentation format of the offer. */
	presentationType: PresentationType;
	/** Website URL of the offer page. */
	standardWebURL?: Maybe<Scalars['String']>;
	/** Deeplink URL directly playing an offer. */
	deeplinkURL?: Maybe<Scalars['String']>;
	/** The formatted (price + currency) price of the offer (monetization type BUY/RENT). */
	retailPrice?: Maybe<Scalars['String']>;
	/** The raw price of the offer (monetization type BUY/RENT). */
	retailPriceValue?: Maybe<Scalars['Float']>;
	/** The formatted (price + currency) price that the offer had before it changed to the current one. */
	lastChangeRetailPrice?: Maybe<Scalars['String']>;
	/** The raw price that the offer had before it changed to the current one. */
	lastChangeRetailPriceValue?: Maybe<Scalars['Float']>;
	/** The price difference in percentage between the previous offer and the current one. */
	lastChangePercent?: Maybe<Scalars['Float']>;
	/** The date of the last offer price change. */
	lastChangeDate?: Maybe<Scalars['Date']>;
	/** The pricings currency. */
	currency?: Maybe<Scalars['String']>;
	/** In the case of aggregated offers, the number of aggregated elements. */
	elementCount?: Maybe<Scalars['Int']>;
	/** In the case of aggregated offers, the number of new aggregated elements, created at the 'dateCreated' date. */
	newElementCount?: Maybe<Scalars['Int']>;
	/** The date when the offer was created. In the case of aggregated offers, it becomes the max/last creation date of the aggregated offers. */
	dateCreated?: Maybe<Scalars['Date']>;
	/** The date at which the offer will be leaving the package. */
	availableTo?: Maybe<Scalars['Date']>;
};

/**
 * Defines the offering of a package for a certain Content title. Unique key is (jwEntityID, country, packageId, monetizationType, presentationType).
 *
 * e.g. 'The Matrix', 'US', 'Netflix', 'Flatrate', '4K'
 */
export type OfferDeeplinkUrlArgs = {
	platform: Platform;
};

/**
 * Defines the offering of a package for a certain Content title. Unique key is (jwEntityID, country, packageId, monetizationType, presentationType).
 *
 * e.g. 'The Matrix', 'US', 'Netflix', 'Flatrate', '4K'
 */
export type OfferRetailPriceArgs = {
	language: Scalars['Language'];
};

/**
 * Defines the offering of a package for a certain Content title. Unique key is (jwEntityID, country, packageId, monetizationType, presentationType).
 *
 * e.g. 'The Matrix', 'US', 'Netflix', 'Flatrate', '4K'
 */
export type OfferLastChangeRetailPriceArgs = {
	language: Scalars['Language'];
};

/** This filter allows filtering of a list of offers. */
export type OfferFilter = {
	/** Keep only the offers having the given packages. Short names are expected (e.g. 'nfx' for Netflix). */
	packages?: Maybe<Array<Scalars['String']>>;
	/** Exclude the offers having the given packages. Short names are expected (e.g. 'nfx' for Netflix). */
	excludePackages?: Maybe<Array<Scalars['String']>>;
	/** Keep only the offers having the given presentation types. */
	presentationTypes?: Maybe<Array<PresentationType>>;
	/** Keep only the offers having the given monetization types. */
	monetizationTypes?: Maybe<Array<MonetizationType>>;
	/** Only keep the best offer per package. */
	bestOnly?: Maybe<Scalars['Boolean']>;
};

/** Indicates if an offer is raw or aggregated from other offers. */
export enum OfferType {
	/**
	 * Aggerated offers exist on shows/seasons.
	 * Usually, we don't get any offers for shows, they're mostly set at the episode level.
	 * That's why for example we aggregate offers for shows: so we don't have to subquery all the episodes to find out where is it watchable.
	 */
	Aggregated = 'AGGREGATED',
	/** A normal raw offer. */
	Standard = 'STANDARD',
}

/** An offer package. Defined by Content. */
export type Package = Node & {
	__typename?: 'Package';
	/** The global node ID. */
	id: Scalars['ID'];
	/** The Content ID of the package. */
	packageId: Scalars['Int'];
	/**
	 * A unique string identifier for the package.
	 *
	 * e.g. 'netflix', 'amazonprime'
	 */
	technicalName: Scalars['String'];
	/**
	 * The short version of the technical name using 3 letters.
	 *
	 * e.g. 'netflix' -> 'nfx'
	 */
	shortName: Scalars['String'];
	/**
	 * The clear human readable name of the package.
	 *
	 * e.g. 'Netflix', 'Amazon Prime'
	 */
	clearName: Scalars['String'];
	/** The slug of the package, used to build the package landing page urls. */
	slug: Scalars['String'];
	/** The monetization types supported by the package. */
	monetizationTypes: Array<MonetizationType>;
	/**
	 * The package icon URL.
	 * It takes a desired size (called profile) and desired format as parameter.
	 *
	 * e.g. 's40' + 'webp' -> '/icon/207360008/s40/netflix.webp'
	 */
	icon: Scalars['String'];
	/**
	 * The blur hash representation of the icon.
	 *
	 * Generated using https://github.com/woltapp/blurhash.
	 */
	iconBlurHash?: Maybe<Scalars['String']>;
	/**
	 * The parent of this addon.
	 *
	 * e.g. 'Amazon Prime Starz' channel has an 'Amazon Prime' parent.
	 */
	addonParent?: Maybe<Package>;
	/**
	 * The addons under this package.
	 *
	 * e.g. 'Amazon Prime' has an 'Amazon Prime Starz' channel.
	 */
	addons: Array<Package>;
	/**
	 * The bundles that contains the package.
	 *
	 * e.g. 'The Sky TV + Ultimate TV' bundle contains 'Sky Go' and 'Netflix'.
	 */
	bundles: Array<Bundle>;
	/** Indicates if the package was selected by the user. */
	selected: Scalars['Boolean'];
	/** Indicates if the package has title contents. */
	hasTitles?: Maybe<Scalars['Boolean']>;
	/** Indicates if the package contains sports. */
	hasSport?: Maybe<Scalars['Boolean']>;
};

/** An offer package. Defined by Content. */
export type PackageIconArgs = {
	profile?: Maybe<IconProfile>;
	format?: Maybe<ImageFormat>;
};

/** An offer package. Defined by Content. */
export type PackageAddonParentArgs = {
	country: Scalars['Country'];
	platform: Platform;
};

/** An offer package. Defined by Content. */
export type PackageAddonsArgs = {
	country: Scalars['Country'];
	platform: Platform;
};

/** An offer package. Defined by Content. */
export type PackageBundlesArgs = {
	country: Scalars['Country'];
	platform: Platform;
	selectedOnly?: Maybe<Scalars['Boolean']>;
};

/** An offer package. Defined by Content. */
export type PackageHasTitlesArgs = {
	country: Scalars['Country'];
	platform: Platform;
};

/** An offer package. Defined by Content. */
export type PackageHasSportArgs = {
	country: Scalars['Country'];
	platform: Platform;
};

/** A static page. Defined by Content. */
export type Page = Node & {
	__typename?: 'Page';
	/** The global node ID. */
	id: Scalars['ID'];
	/**
	 * The static page technical name.
	 *
	 * e.g. 'VIEW_POPULAR'
	 */
	technicalName: Scalars['String'];
	/** The translated name of the page. */
	translation?: Maybe<Scalars['String']>;
};

/** The information for paginating a connection. */
export type PageInfo = {
	__typename?: 'PageInfo';
	/** The pagination cursor to use to fetch the previous page. */
	startCursor: Scalars['String'];
	/** The pagination cursor to use to fetch the next page. */
	endCursor: Scalars['String'];
	/** Flag indicating if a previous page in present. */
	hasPreviousPage: Scalars['Boolean'];
	/** Flag indicating if a next page in present. */
	hasNextPage: Scalars['Boolean'];
};

/** Personalized person aggregating user data and static Content data. */
export type Person = Title &
	Node & {
		__typename?: 'Person';
		/** The global node ID. */
		id: Scalars['ID'];
		/** The Content type of the title. */
		objectType: ObjectType;
		/** The Content ID of the title. */
		objectId: Scalars['Int'];
		/** The person data. It is localized by country and language. */
		content: PersonContent;
	};

/** Personalized person aggregating user data and static Content data. */
export type PersonContentArgs = {
	country: Scalars['Country'];
	language: Scalars['Language'];
};

/** Unpersonalized person data common to all the users, as defined by Content. It is localized by country and language. */
export type PersonContent = {
	__typename?: 'PersonContent';
	/** The name of the person. */
	fullName: Scalars['String'];
	/** A short description of the person. */
	shortDescription?: Maybe<Scalars['String']>;
	/** The date of birth of the person. */
	dateOfBirth?: Maybe<Scalars['Date']>;
};

/** The person filter. */
export type PersonFilter = {
	/** Fuzzy search using the given query string. */
	searchQuery?: Maybe<Scalars['String']>;
};

/** The platform on which the app is running. */
export enum Platform {
	/** This is for the web app. */
	Web = 'WEB',
	/** This is for Android. */
	Android = 'ANDROID',
	/** This is for iOS. */
	Ios = 'IOS',
	/** This is a Fire TV. */
	FireTv = 'FIRE_TV',
	/** This is an Android TV. */
	AndroidTv = 'ANDROID_TV',
	/** This is an Apple TV. */
	Tvos = 'TVOS',
	/** This is a webOS based Smart TV (mainly LG). */
	Webos = 'WEBOS',
	/** This is a Tizen based Smart TV (mainly Samsung). */
	Tizenos = 'TIZENOS',
	/** This is a Xbox. */
	Xbox = 'XBOX',
	/** This is a PlayStation. */
	Playstation = 'PLAYSTATION',
	/** This is for Roku OS. */
	RokuOs = 'ROKU_OS',
}

/** The input needed to designate the title that will played. */
export type PlayTitleInput = {
	/** The global title ID as defined by Content. */
	jwEntityID: Scalars['String'];
	/** The optional id of the device we want to play the title on. We broadcast if not set. WARNING: The node ID is expected here. */
	deviceID?: Maybe<Scalars['ID']>;
};

/** The payload response of the play title instruction. */
export type PlayTitlePayload = {
	__typename?: 'PlayTitlePayload';
	/** The title object that the listening devices received. */
	title: MovieOrShowOrSeasonOrEpisode;
	/**
	 * The ids of the devices that received the event.
	 * @deprecated Please use the 'devices' field
	 */
	deviceIDs: Array<Scalars['ID']>;
	/** The devices that received the event. */
	devices: Array<Device>;
	/** Indicates if the push was successful, i.e. if at least one device received the event. */
	success: Scalars['Boolean'];
};

/** The code and UUID obtained from the TV code endpoint. */
export type PollForTvJwtInput = {
	/** The code we're displaying to the user. */
	code: Scalars['String'];
	/** The security UUID. */
	uuid: Scalars['String'];
};

/** The payload response of the TV JWT polling. */
export type PollForTvJwtPayload = {
	__typename?: 'PollForTvJwtPayload';
	/** The Firebase JWT of the linked account. Null if no account is connected yet. */
	jwt?: Maybe<Scalars['String']>;
};

/** A connection object for the popular people. */
export type PopularPeopleConnection = {
	__typename?: 'PopularPeopleConnection';
	/** The total number of items. */
	totalCount: Scalars['Int'];
	/** The edges for each of the items. */
	edges?: Maybe<Array<PopularPeopleEdge>>;
	/** Information for paginating this connection. */
	pageInfo: PageInfo;
};

/** An edge object for the popular people. */
export type PopularPeopleEdge = {
	__typename?: 'PopularPeopleEdge';
	/** A cursor used for pagination. */
	cursor: Scalars['String'];
	/** The node represented by this edge. */
	node: Person;
};

/** The field/info to order titles by. */
export enum PopularPeopleSorting {
	/** Sorted by TMDB popularity. */
	TmdbPopularity = 'TMDB_POPULARITY',
}

/** A connection object for the popular titles. */
export type PopularTitlesConnection = {
	__typename?: 'PopularTitlesConnection';
	/** The total number of items. */
	totalCount: Scalars['Int'];
	/** Indicates if a sponsored recommendation is currently active for the user. */
	activeCampaign?: Maybe<SponsoredRecommendationCampaign>;
	/** The edges for each of the items. */
	edges?: Maybe<Array<PopularTitlesEdge>>;
	/** Information for paginating this connection. */
	pageInfo: PageInfo;
};

/** An edge object for the popular titles. */
export type PopularTitlesEdge = {
	__typename?: 'PopularTitlesEdge';
	/** A cursor used for pagination. */
	cursor: Scalars['String'];
	/** The node represented by this edge. */
	node: MovieOrShow;
};

/** The field/info to order titles by. */
export enum PopularTitlesSorting {
	/** Sorted by JW popularity score. */
	Popular = 'POPULAR',
	/** Sorted by JW trending score. */
	Trending = 'TRENDING',
	/** Sorted randomly, based on the provided randomSeed. */
	Random = 'RANDOM',
	/** Sorted by title. */
	Alphabetical = 'ALPHABETICAL',
	/** Sorted by release year. */
	ReleaseYear = 'RELEASE_YEAR',
	/** Sorted by TMDB popularity. */
	TmdbPopularity = 'TMDB_POPULARITY',
	/** Sorted by IMDB score. */
	ImdbScore = 'IMDB_SCORE',
	/** Sorted by runtime. */
	Runtime = 'RUNTIME',
	/** Sorted by User Taste. */
	Relevance = 'RELEVANCE',
	/** Sorted by offer Available To date. */
	AvailableTo = 'AVAILABLE_TO',
}

/** Popularity rank for each title and its related titles in the rankings. */
export type PopularityRank = {
	__typename?: 'PopularityRank';
	/** List of neighboring popular title objects and its rank for the streaming chart. */
	titles: Array<MovieOrShowOrSeason>;
	/** The popularity rank for the current object. */
	rank: Scalars['Int'];
	/** The moving window of the current title popularity in the last 30 days. */
	trend: ModuleContentTitleTrend;
	/** Rank difference change popularity in the last 30 days. */
	trendDifference: Scalars['Int'];
};

/** The type for which the popularity ranks are based on */
export enum PopularityRankTypes {
	/** Daily popularity titles for the same content type. for ex: if the title movie is chosen all the titles returned will be the movie type. */
	DailyPopularitySameContentType = 'DAILY_POPULARITY_SAME_CONTENT_TYPE',
	/** Daily popularity titles for movie, show and season object types. */
	DailyPopularityAllContentType = 'DAILY_POPULARITY_ALL_CONTENT_TYPE',
	/** Weekly popularity titles for the same content type. for ex: if the title movie is chosen all the titles returned will be the movie type. */
	WeeklyPopularitySameContentType = 'WEEKLY_POPULARITY_SAME_CONTENT_TYPE',
	/** Weekly popularity titles for movie, show and season object types. */
	WeeklyPopularityAllContentType = 'WEEKLY_POPULARITY_ALL_CONTENT_TYPE',
}

/** A list of image sizes supported by the scaler for posters. */
export enum PosterProfile {
	/** 166x236 */
	S166 = 'S166',
	/** 276x392 */
	S276 = 'S276',
	/** 332x472 */
	S332 = 'S332',
	/** 592x841 */
	S592 = 'S592',
	/** 718x1024 */
	S718 = 'S718',
}

/** The quality/medium of an offer. */
export enum PresentationType {
	/** An SD quality. */
	Sd = 'SD',
	/** An HD quality. */
	Hd = 'HD',
	/** A 4K or UHD quality. */
	'4K' = '_4K',
	/** A DVD medium. */
	Dvd = 'DVD',
	/** A Bluray medium. */
	Bluray = 'BLURAY',
	/** A canvas medium. Used for cinema offers. */
	Canvas = 'CANVAS',
}

/** An edge object for promoted bundles. */
export type PromotedBundleEdge = {
	__typename?: 'PromotedBundleEdge';
	/** The node represented by this edge. */
	node: Bundle;
	/** The promotion url for the bundle. */
	promotionUrl: Scalars['String'];
	/** The offer that triggered the bundle promotion. */
	offer: Offer;
};

/** The query root of JustWatch's GraphQL interface. */
export type Query = {
	__typename?: 'Query';
	/** Fetches an object given its ID. */
	node?: Maybe<Node>;
	/** Fetches multiple objects by IDs. */
	nodes: Array<Maybe<Node>>;
	/** Returns the user settings. */
	settings: Settings;
	/** Returns a list of devices linked to the user account and ready to play a title. */
	playTitleDevices: Array<Device>;
	/** Returns some user statistics. */
	stats: UserStats;
	/**
	 * Looks up a URL by its full path (e.g. '/de/Film/Spider-Man-Far-from-Home').
	 * @deprecated Field no longer supported
	 */
	url: Url;
	/**
	 * Looks up a URL by its full path (e.g. '/de/Film/Spider-Man-Far-from-Home').
	 *
	 * By setting a node ID in an 'id' query parameter, the front-end can tell the api to fetch and attach the node to the url.
	 */
	urlV2: Url;
	/** Returns the packages available in your country on your platform. */
	packages: Array<Package>;
	/** Runs a title search and returns a paginated list of results. Returns movies and shows. */
	popularTitles: PopularTitlesConnection;
	/** Runs a person search and returns a paginated list of results. Returns people. */
	popularPeople: PopularPeopleConnection;
	/** Runs a title search and returns an aggregated list of titles. */
	newTitleBuckets: NewTitleBucketsConnection;
	/** Runs a title search for newly releases titles. Returns movies and seasons. */
	newTitles: NewTitlesConnection;
	/** Returns the title list of a user. */
	titleList: TitleListConnection;
	/** Public generic title lists. */
	genericTitleList: GenericTitleListConnection;
	/** My lists and the public title lists that I follow. */
	genericTitleLists: GenericTitleListsConnection;
	/** Returns all the locales/countries supported by JustWatch. */
	locales: Array<LocaleState>;
	/** Returns all the languages supported by JustWatch. */
	languages: Array<LanguageState>;
	/** Returns all the genres supported by JustWatch. */
	genres: Array<Genre>;
	/** Returns all the age certifications supported by JustWatch. */
	ageCertifications: Array<AgeCertification>;
	/** Returns all the sport competitions */
	sportCompetitionsV2: SportCompetitionsConnectionV2;
	/** Runs a sport event search and returns an aggregated list of sport events. */
	sportEventBucketsV2: SportEventBucketsConnectionV2;
	/** Runs a sport event search. */
	sportEventsV2: SportEventsConnectionV2;
	/** Runs a mySport event search and returns an aggregated list of mySport events. */
	mySportEventBuckets: MySportEventBucketsConnection;
	/** Runs a mySport event search. */
	mySportEvents: MySportEventsConnection;
	/** Returns a sport event matrix. */
	sportEventMatrix: SportEventMatrix;
	/** Returns a list of discovery modules. */
	discoveryModules: DiscoveryModulesConnection;
	/** Returns a list of discovery modules. */
	discoveryModulesV2: DiscoveryModuleLayout;
	/** Gets the stripe checkout session status */
	getStripeCheckoutSessionStatus?: Maybe<StripeCheckoutSessionStatusType>;
	/** Get the Ephemeral module contents based on the technical and anchor mood type. */
	ephemeralModules: EphemeralModule;
	/** Fetch the next title suggestions based on the taste survey input selections. */
	tasteSurveyNextTitle: TasteSurveyNextTitle;
	/** Search for articles written by authors. */
	articles: ArticlesConnection;
	/** Get the current active campaigns for the user. */
	activeSponsoredRecommendationCampaigns?: Maybe<Array<SponsoredRecommendationCampaign>>;
};

/** The query root of JustWatch's GraphQL interface. */
export type QueryNodeArgs = {
	id: Scalars['ID'];
};

/** The query root of JustWatch's GraphQL interface. */
export type QueryNodesArgs = {
	ids: Array<Scalars['ID']>;
};

/** The query root of JustWatch's GraphQL interface. */
export type QueryUrlArgs = {
	fullPath: Scalars['String'];
};

/** The query root of JustWatch's GraphQL interface. */
export type QueryUrlV2Args = {
	fullPath: Scalars['String'];
};

/** The query root of JustWatch's GraphQL interface. */
export type QueryPackagesArgs = {
	country: Scalars['Country'];
	platform: Platform;
	monetizationTypes?: Maybe<Array<MonetizationType>>;
	includeAddons?: Maybe<Scalars['Boolean']>;
	iosPackages?: Maybe<Scalars['Boolean']>;
	hasTitles?: Maybe<Scalars['Boolean']>;
	hasSport?: Maybe<Scalars['Boolean']>;
};

/** The query root of JustWatch's GraphQL interface. */
export type QueryPopularTitlesArgs = {
	country: Scalars['Country'];
	first?: Scalars['Int'];
	after?: Maybe<Scalars['String']>;
	filter?: Maybe<TitleFilter>;
	sortBy?: PopularTitlesSorting;
	sortRandomSeed?: Scalars['Int'];
	allowSponsoredRecommendations?: Maybe<SponsoredRecommendationsInput>;
};

/** The query root of JustWatch's GraphQL interface. */
export type QueryPopularPeopleArgs = {
	country: Scalars['Country'];
	first?: Scalars['Int'];
	after?: Maybe<Scalars['String']>;
	filter?: Maybe<PersonFilter>;
	sortBy?: PopularPeopleSorting;
};

/** The query root of JustWatch's GraphQL interface. */
export type QueryNewTitleBucketsArgs = {
	country: Scalars['Country'];
	first?: Scalars['Int'];
	after?: Maybe<Scalars['String']>;
	bucketSize?: Maybe<Scalars['Int']>;
	filter?: Maybe<TitleFilter>;
	groupBy?: NewTitleAggregation;
	priceDrops?: Scalars['Boolean'];
	pageType?: NewPageType;
	allowSponsoredRecommendations?: Maybe<SponsoredRecommendationsInput>;
};

/** The query root of JustWatch's GraphQL interface. */
export type QueryNewTitlesArgs = {
	country: Scalars['Country'];
	first?: Scalars['Int'];
	after?: Maybe<Scalars['String']>;
	filter?: Maybe<TitleFilter>;
	date?: Maybe<Scalars['Date']>;
	bucketType?: Maybe<NewDateRangeBucket>;
	package?: Maybe<Scalars['String']>;
	priceDrops?: Scalars['Boolean'];
	pageType?: NewPageType;
	allowSponsoredRecommendations?: Maybe<SponsoredRecommendationsInput>;
};

/** The query root of JustWatch's GraphQL interface. */
export type QueryTitleListArgs = {
	country: Scalars['Country'];
	objectType: TitleListObjectType;
	titleListType: TitleListType;
	subheading?: Maybe<TitleListSubheadingTechnicalName>;
	first?: Scalars['Int'];
	after?: Maybe<Scalars['String']>;
	filter?: Maybe<TitleFilter>;
	sortBy?: TitleListSorting;
	sortRandomSeed?: Scalars['Int'];
};

/** The query root of JustWatch's GraphQL interface. */
export type QueryGenericTitleListArgs = {
	id: Scalars['ID'];
	country: Scalars['Country'];
	first?: Scalars['Int'];
	after?: Maybe<Scalars['String']>;
	filter?: Maybe<TitleFilter>;
	sortBy?: GenericTitleListSorting;
	sortRandomSeed?: Scalars['Int'];
};

/** The query root of JustWatch's GraphQL interface. */
export type QueryGenericTitleListsArgs = {
	type: GenericTitleListsType;
	first?: Scalars['Int'];
	after?: Maybe<Scalars['String']>;
};

/** The query root of JustWatch's GraphQL interface. */
export type QueryAgeCertificationsArgs = {
	country: Scalars['Country'];
	objectType?: Maybe<AgeCertificationObjectType>;
};

/** The query root of JustWatch's GraphQL interface. */
export type QuerySportCompetitionsV2Args = {
	country: Scalars['Country'];
	first?: Scalars['Int'];
	after?: Maybe<Scalars['String']>;
	filter?: Maybe<SearchSportCompetitionFilter>;
};

/** The query root of JustWatch's GraphQL interface. */
export type QuerySportEventBucketsV2Args = {
	country: Scalars['Country'];
	first?: Scalars['Int'];
	after?: Maybe<Scalars['String']>;
	bucketSize?: Maybe<Scalars['Int']>;
	filter?: Maybe<SportEventFilter>;
	groupBy?: SportEventAggregation;
	timezoneOffset: Scalars['Int'];
};

/** The query root of JustWatch's GraphQL interface. */
export type QuerySportEventsV2Args = {
	country: Scalars['Country'];
	first?: Scalars['Int'];
	after?: Maybe<Scalars['String']>;
	filter?: Maybe<SportEventFilter>;
	timezoneOffset: Scalars['Int'];
};

/** The query root of JustWatch's GraphQL interface. */
export type QueryMySportEventBucketsArgs = {
	country: Scalars['Country'];
	first?: Scalars['Int'];
	after?: Maybe<Scalars['String']>;
	bucketSize?: Maybe<Scalars['Int']>;
	filter?: Maybe<SportEventFilter>;
	groupBy?: SportEventAggregation;
	timezoneOffset: Scalars['Int'];
};

/** The query root of JustWatch's GraphQL interface. */
export type QueryMySportEventsArgs = {
	country: Scalars['Country'];
	first?: Scalars['Int'];
	after?: Maybe<Scalars['String']>;
	filter?: Maybe<SportEventFilter>;
	timezoneOffset: Scalars['Int'];
};

/** The query root of JustWatch's GraphQL interface. */
export type QuerySportEventMatrixArgs = {
	country: Scalars['Country'];
	first?: Scalars['Int'];
	bucketSize?: Scalars['Int'];
	sport: SportType;
	aggregation: SportEventMatrixAggregation;
	filter?: Maybe<SportEventFilter>;
};

/** The query root of JustWatch's GraphQL interface. */
export type QueryDiscoveryModulesArgs = {
	country: Scalars['Country'];
	language: Scalars['Language'];
	first?: Scalars['Int'];
	after?: Maybe<Scalars['String']>;
	forceNewDiscoverySession?: Scalars['Boolean'];
	sponsoredRecommendationMode?: Scalars['Boolean'];
	supportedModuleTemplates: Array<Scalars['String']>;
	postFilter?: Maybe<DiscoveryModulesPostFilter>;
	allowSponsoredRecommendations?: Maybe<SponsoredRecommendationsInput>;
};

/** The query root of JustWatch's GraphQL interface. */
export type QueryDiscoveryModulesV2Args = {
	country: Scalars['Country'];
	platform: Platform;
	supportedContentTypes: Array<ModuleContentType>;
	promotionMode?: Maybe<ModulePromotionMode>;
	testingMode?: Scalars['Boolean'];
	allowSponsoredRecommendations?: Maybe<SponsoredRecommendationsInput>;
};

/** The query root of JustWatch's GraphQL interface. */
export type QueryGetStripeCheckoutSessionStatusArgs = {
	input: StripeCheckoutSessionStatusInput;
};

/** The query root of JustWatch's GraphQL interface. */
export type QueryEphemeralModulesArgs = {
	country: Scalars['Country'];
	language: Scalars['Language'];
	moduleTemplates: Array<EphemeralModuleTemplateInput>;
};

/** The query root of JustWatch's GraphQL interface. */
export type QueryTasteSurveyNextTitleArgs = {
	newLikedJWEntityIDs?: Maybe<Array<Scalars['String']>>;
	count: Scalars['Int'];
	country: Scalars['Country'];
	language: Scalars['Language'];
};

/** The query root of JustWatch's GraphQL interface. */
export type QueryArticlesArgs = {
	country: Scalars['Country'];
	first?: Scalars['Int'];
	after?: Maybe<Scalars['String']>;
	filter?: Maybe<ArticleFilter>;
};

/** The query root of JustWatch's GraphQL interface. */
export type QueryActiveSponsoredRecommendationCampaignsArgs = {
	input: SponsoredRecommendationsInput;
};

/** The payload response of an auth/identity action registration. */
export type RegisterPayload = {
	__typename?: 'RegisterPayload';
	/** The login id of the user. */
	loginId: Scalars['String'];
};

/** The release type of a title. */
export enum ReleaseType {
	/** Released on streaming media. */
	Digital = 'DIGITAL',
	/** Released in cinema. */
	Theatrical = 'THEATRICAL',
}

/** The input needed to report the feedback. */
export type ReportFeedbackInput = {
	/** The node id. */
	id: Scalars['ID'];
	/** The type of issue related to the content. */
	type: IssueReportType;
	/** The country of the user. */
	country: Scalars['Country'];
	/** The user's preferred language in the platform. */
	language: Scalars['Language'];
	/** Link to the external provider's page. */
	externalUrl?: Maybe<Scalars['String']>;
	/** The package that issue is related to. Short names are expected (e.g. 'nfx' for Netflix). */
	package?: Maybe<Scalars['String']>;
	/** Any additional comment or description that can describe the issue breifly. */
	comment?: Maybe<Scalars['String']>;
	/** Email information of the user, if user wishes to receive the update on the reported issue. */
	email?: Maybe<Scalars['String']>;
	/** Platform information and its version. for e.g, 3.3.10-webapp */
	platformVersion: Scalars['String'];
};

/** The payload response for the reported feedback. */
export type ReportFeedbackPayload = {
	__typename?: 'ReportFeedbackPayload';
	/** The result of the reported issue submission status. */
	isReported: Scalars['Boolean'];
};

/** Defines the permissions of a user. */
export enum Role {
	/** A non logged in user. */
	Guest = 'GUEST',
	/** A logged in user. */
	LoggedIn = 'LOGGED_IN',
}

/** Score associated to each title */
export type Score = {
	__typename?: 'Score';
	providerType?: Maybe<Scalars['String']>;
	value?: Maybe<Scalars['Float']>;
};

/** A set of ratings/scorings associated to a title. */
export type Scoring = {
	__typename?: 'Scoring';
	/** The TMDB popularity. */
	tmdbPopularity?: Maybe<Scalars['Float']>;
	/** The TMDB score. */
	tmdbScore?: Maybe<Scalars['Float']>;
	/** The IMDB rating. */
	imdbScore?: Maybe<Scalars['Float']>;
	/** The IMDB number of votes. */
	imdbVotes?: Maybe<Scalars['Float']>;
	/** The virality score, between 0 and 1. */
	viral?: Maybe<Scalars['Float']>;
};

/** Search Sport Competition filter. */
export type SearchSportCompetitionFilter = {
	/** Search sports filtered by time */
	activeOn?: Maybe<Scalars['Time']>;
};

/** Personalized season aggregating user data and static Content data. */
export type Season = MovieOrSeason &
	MovieOrShowOrSeason &
	MovieOrShowOrSeasonOrEpisode &
	Title &
	Node & {
		__typename?: 'Season';
		/**
		 * The global node ID of the title. For titles, it is defined by Content and made from object type + object ID.
		 *
		 * e.g. 'tm21' -> 'movie' + 21, 'tss11' -> 'show_season' + 11
		 */
		id: Scalars['ID'];
		/** The Content type of the title. */
		objectType: ObjectType;
		/** The Content ID of the title. */
		objectId: Scalars['Int'];
		/** The date where the title is leaving the users provider. */
		availableTo: Array<AvailableTo>;
		/** The title data. It is localized by country and language. */
		content: SeasonContent;
		/** The offers available on packages for the title. Depends on the country being set. */
		offers: Array<Offer>;
		/** The offer count available on packages for the title. Depends on the country being set.  */
		offerCount: Scalars['Int'];
		/** The offers promoted for this title. Depends on the country being set. */
		promotedOffers: Array<Offer>;
		/** The bundles promoted for this title. Calculated from the offers. Depends on the country being set. */
		promotedBundles: Array<PromotedBundleEdge>;
		/**
		 * The default offer that should be used to play the title. Can be null if there are no matching offers.
		 *
		 * A default monetization type filter is applied to only keep flatrate/free offers.
		 */
		watchNowOffer?: Maybe<Offer>;
		/** The popularity rank and its trend popularity behaviour for the given title and its neighbouring titles. */
		popularityRank: PopularityRank;
		/** The total number of existing episodes for this show. */
		totalEpisodeCount: Scalars['Int'];
		/** The episodes included in this season. */
		episodes: Array<Episode>;
		/** The parent show of this season. */
		show: Show;
		/** Returns the Watch Next episode: the first unseen episode following the last seen episode (by timestamp). */
		watchNextEpisode?: Maybe<Episode>;
		/**
		 * For seasons, knowing what is seen is a bit more complicated since the seen data is stored at the episode level.
		 * So we calculate it based on the episodes.
		 */
		seenState: ShowSeenState;
	};

/** Personalized season aggregating user data and static Content data. */
export type SeasonAvailableToArgs = {
	country: Scalars['Country'];
	platform: Platform;
	packages?: Maybe<Array<Scalars['String']>>;
};

/** Personalized season aggregating user data and static Content data. */
export type SeasonContentArgs = {
	country: Scalars['Country'];
	language: Scalars['Language'];
};

/** Personalized season aggregating user data and static Content data. */
export type SeasonOffersArgs = {
	country: Scalars['Country'];
	platform: Platform;
	filter?: OfferFilter;
};

/** Personalized season aggregating user data and static Content data. */
export type SeasonOfferCountArgs = {
	country: Scalars['Country'];
	platform: Platform;
	filter?: OfferFilter;
	distinctPackages?: Scalars['Boolean'];
};

/** Personalized season aggregating user data and static Content data. */
export type SeasonPromotedOffersArgs = {
	country: Scalars['Country'];
	platform: Platform;
	filter?: OfferFilter;
};

/** Personalized season aggregating user data and static Content data. */
export type SeasonPromotedBundlesArgs = {
	country: Scalars['Country'];
	platform: Platform;
	filter?: OfferFilter;
};

/** Personalized season aggregating user data and static Content data. */
export type SeasonWatchNowOfferArgs = {
	country: Scalars['Country'];
	platform: Platform;
	filter?: WatchNowOfferFilter;
};

/** Personalized season aggregating user data and static Content data. */
export type SeasonPopularityRankArgs = {
	country: Scalars['Country'];
	previousTitles?: Scalars['Int'];
	nextTitles?: Scalars['Int'];
	category?: PopularityRankTypes;
};

/** Personalized season aggregating user data and static Content data. */
export type SeasonEpisodesArgs = {
	releasedInCountry?: Maybe<Scalars['Country']>;
	sortDirection?: SortDirection;
	limit?: Maybe<Scalars['Int']>;
};

/** Personalized season aggregating user data and static Content data. */
export type SeasonWatchNextEpisodeArgs = {
	country: Scalars['Country'];
	includeUnreleasedEpisodes?: Scalars['Boolean'];
};

/** Personalized season aggregating user data and static Content data. */
export type SeasonSeenStateArgs = {
	country: Scalars['Country'];
};

/** Unpersonalized season data common to all the users, as defined by Content. It is localized by country and language. */
export type SeasonContent = MovieOrSeasonContent &
	MovieOrShowOrSeasonContent &
	MovieOrShowOrSeasonOrEpisodeContent & {
		__typename?: 'SeasonContent';
		/** The localized title of the title. Depends on the language being set. */
		title: Scalars['String'];
		/** A short description of the title. */
		shortDescription?: Maybe<Scalars['String']>;
		/** The duration of the title. For shows and seasons, it's the average runtime of an episode. */
		runtime?: Maybe<Scalars['Int']>;
		/** The year when the title was originally first released. */
		originalReleaseYear?: Maybe<Scalars['Int']>;
		/** The date when the title was originally first released. */
		originalReleaseDate?: Maybe<Scalars['Date']>;
		/** The date when the title was first released in the country. */
		localizedReleaseDate?: Maybe<Scalars['Date']>;
		/** Whether we consider the title as released or not. */
		isReleased: Scalars['Boolean'];
		/** The title upcoming releases on streaming or cinema. Sorted by release date. */
		upcomingReleases: Array<UpcomingRelease>;
		/**
		 * The localized website detail page URL of the title. Depends on the country being set.
		 *
		 * e.g. '/us/movie/batman-the-dark-knight'
		 */
		fullPath: Scalars['String'];
		/** The related genre objects. */
		genres: Array<Genre>;
		/** The trailers/clips attached to the title. */
		clips: Array<Clip>;
		/**
		 * The localized poster URL. Depends on the country and language being set.
		 * It takes a desired size (called profile) and desired format as parameter.
		 *
		 * e.g. 's166' + 'webp' -> '/poster/8711516/s166/memento.webp'
		 */
		posterUrl?: Maybe<Scalars['String']>;
		/**
		 * The blur hash representation of the poster.
		 *
		 * Generated using https://github.com/woltapp/blurhash.
		 */
		posterBlurHash?: Maybe<Scalars['String']>;
		/**
		 * A list of backdrops. It takes a desired size (called profile) and desired format as parameter.
		 *
		 * e.g. 's1440' + 'webp' -> '/backdrop/8711516/s1440/Spider-Man-Homecoming.webp'
		 */
		backdrops: Array<Backdrop>;
		/** All the scorings/ratings of the title. */
		scoring: Scoring;
		/** All the IDs of the title on external platforms. */
		externalIds: ExternalIds;
		/** The season number. */
		seasonNumber: Scalars['Int'];
	};

/** Unpersonalized season data common to all the users, as defined by Content. It is localized by country and language. */
export type SeasonContentUpcomingReleasesArgs = {
	releaseTypes?: Maybe<Array<ReleaseType>>;
	packages?: Maybe<Array<Scalars['String']>>;
};

/** Unpersonalized season data common to all the users, as defined by Content. It is localized by country and language. */
export type SeasonContentClipsArgs = {
	providers?: Maybe<Array<ClipProvider>>;
};

/** Unpersonalized season data common to all the users, as defined by Content. It is localized by country and language. */
export type SeasonContentPosterUrlArgs = {
	profile?: Maybe<PosterProfile>;
	format?: Maybe<ImageFormat>;
};

/** Unpersonalized season data common to all the users, as defined by Content. It is localized by country and language. */
export type SeasonContentBackdropsArgs = {
	profile?: Maybe<BackdropProfile>;
	format?: Maybe<ImageFormat>;
};

/** Indicates the number of sessions that the user had for every platform. BI data. */
export type SessionsPerPlatform = {
	__typename?: 'SessionsPerPlatform';
	/** Number of sessions in total. */
	total: Scalars['Int'];
	/** Number of sessions on web. */
	web: Scalars['Int'];
	/** Number of sessions on TV. */
	tv: Scalars['Int'];
	/** Number of sessions on mobile. */
	mob: Scalars['Int'];
};

export type SetBundleInput = {
	/** The country of the user. */
	country: Scalars['Country'];
	/** The platform of the user. */
	platform: Platform;
	/** The bundle to add/remove from the settings. Short names are expected (e.g. 'npp' for Netflix+Prime). */
	bundle: Scalars['String'];
	/** Whether we should add or remove the bundle. */
	state: Scalars['Boolean'];
};

/** The title we want to add/remove in the custom list. Movies and shows can be manipulated. */
export type SetInCustomlistInput = {
	/** The list id we want to add the node to. */
	listId: Scalars['ID'];
	/** The node id. */
	id: Scalars['ID'];
	/** Whether we should add or remove a title from the list. */
	state: Scalars['Boolean'];
};

/** The title list we want to add/remove to the followed lists. */
export type SetInFollowedListInput = {
	/** The node id. */
	id: Scalars['ID'];
	/** Whether we should add or remove a list from the followed list. */
	state: Scalars['Boolean'];
	/** An overwrite name for the followed list. */
	name: Scalars['String'];
};

/** The payload when following/unfollowing a title list. */
export type SetInFollowedListPayload = {
	__typename?: 'SetInFollowedListPayload';
	/** The followed title list. */
	titleList: GenericTitleList;
};

/** The payload response for my sport list. */
export type SetInMysportlistPayload = {
	__typename?: 'SetInMysportlistPayload';
	/** The title that we just added/removed in the list. */
	title: SportTitle;
};

/** The titles we want to add/remove in the seenlist. Movies, shows, seasons and episodes can be manipulated. */
export type SetInSeenlistBatchInput = {
	/** The batch items. */
	items: Array<SetInSeenlistBatchItem>;
	/** The user's country. */
	country: Scalars['Country'];
};

/** A title we want to add/remove in the seenlist in batch. Movies, shows, seasons and episodes can be manipulated. */
export type SetInSeenlistBatchItem = {
	/** The node id. */
	id: Scalars['ID'];
	/** Whether we should add or remove a title from the list. */
	state: Scalars['Boolean'];
};

/** The payload response of a seenlist batch addition/removal. */
export type SetInSeenlistBatchPayload = {
	__typename?: 'SetInSeenlistBatchPayload';
	/** The titles that we just added/removed in the list. */
	titles: Array<MovieOrShowOrSeasonOrEpisode>;
};

/** The title we want to add/remove in the seenlist. Movies, shows, seasons and episodes can be manipulated. */
export type SetInSeenlistInput = {
	/** The node id. */
	id: Scalars['ID'];
	/** Whether we should add or remove a title from the list. */
	state: Scalars['Boolean'];
	/** The user's country. */
	country: Scalars['Country'];
};

/** The payload response of a seenlist addition/removal. */
export type SetInSeenlistPayload = {
	__typename?: 'SetInSeenlistPayload';
	/** The title that we just added/removed in the list. */
	title: MovieOrShowOrSeasonOrEpisode;
};

/** The title we want to add/remove in a standard title list. Only movies or shows can be manipulated. */
export type SetInTitleListInput = {
	/** The node id. */
	id: Scalars['ID'];
	/** Whether we should add or remove a title from the list. */
	state: Scalars['Boolean'];
};

/** The payload response of a title list addition/removal. */
export type SetInTitleListPayload = {
	__typename?: 'SetInTitleListPayload';
	/** The title that we just added/removed in the list. */
	title: MovieOrShow;
};

export type SetPackageInput = {
	/** The country of the user. */
	country: Scalars['Country'];
	/** The platform of the user. */
	platform: Platform;
	/** The package to add/remove from the settings. Short names are expected (e.g. 'nfx' for Netflix). */
	package?: Maybe<Scalars['String']>;
	/** When batching, the packages to add/remove from the settings. Short names are expected (e.g. 'nfx' for Netflix). */
	packages?: Maybe<Array<Scalars['String']>>;
	/** Whether we should add or remove the package. */
	state: Scalars['Boolean'];
	/** In case of a package deselection that was part of a bundle, indicates if we should also deselect the parent bundle. */
	cascadeDeselectBundles?: Maybe<Scalars['Boolean']>;
};

/** The user settings. */
export type Settings = {
	__typename?: 'Settings';
	/** Indicates if the user has been onboarded before going to the Home. */
	tasteSurveyCompleted: Scalars['Boolean'];
	/** Indicates the type of onboarding the user took before going to the Home. */
	tasteSurveyType?: Maybe<TasteSurveyType>;
	/** Indicates the Gefjon model that was used to recommend the onboarding titles. */
	tasteSurveyModelVersion?: Maybe<Scalars['String']>;
	/** Stores the tracking consent data. */
	jwConsents?: Maybe<JwConsents>;
	/** Stores the UserCentrics consent data. */
	ucConsents: Array<UcConsent>;
	/** Used to store the timeline specials hidden by the user. */
	hiddenTimelineSpecials: Array<Scalars['String']>;
	/** The packages selected by the user. Also includes the packages from the selected bundles. */
	selectedPackages: Array<Package>;
	/** The bundles selected by the user. */
	selectedBundles: Array<Bundle>;
};

/** The user settings. */
export type SettingsSelectedPackagesArgs = {
	country: Scalars['Country'];
	platform: Platform;
	iosPackages?: Maybe<Scalars['Boolean']>;
	hasTitles?: Maybe<Scalars['Boolean']>;
	hasSport?: Maybe<Scalars['Boolean']>;
};

/** The user settings. */
export type SettingsSelectedBundlesArgs = {
	country: Scalars['Country'];
	platform: Platform;
};

/** Personalized show aggregating user data and static Content data. */
export type Show = MovieOrShow &
	MovieOrShowOrSeason &
	MovieOrShowOrSeasonOrEpisode &
	Title &
	Node & {
		__typename?: 'Show';
		/**
		 * The global node ID of the title. For titles, it is defined by Content and made from object type + object ID.
		 *
		 * e.g. 'tm21' -> 'movie' + 21, 'tss11' -> 'show_season' + 11
		 */
		id: Scalars['ID'];
		/** The Content type of the title. */
		objectType: ObjectType;
		/** The Content ID of the title. */
		objectId: Scalars['Int'];
		/** The date where the title is leaving the users provider. */
		availableTo: Array<AvailableTo>;
		/** The title data. It is localized by country and language. */
		content: ShowContent;
		/** The offers available on packages for the title. Depends on the country being set. */
		offers: Array<Offer>;
		/** The offer count available on packages for the title. Depends on the country being set.  */
		offerCount: Scalars['Int'];
		/** The offers promoted for this title. Depends on the country being set. */
		promotedOffers: Array<Offer>;
		/** The bundles promoted for this title. Calculated from the offers. Depends on the country being set. */
		promotedBundles: Array<PromotedBundleEdge>;
		/**
		 * The default offer that should be used to play the title. Can be null if there are no matching offers.
		 *
		 * A default monetization type filter is applied to only keep flatrate/free offers.
		 */
		watchNowOffer?: Maybe<Offer>;
		/** The entry for the movie in the watchlist. */
		watchlistEntry?: Maybe<TitleListEntry>;
		/** The entry for the movie in the likelist. */
		likelistEntry?: Maybe<TitleListEntry>;
		/** The entry for the movie in the dislikelist. */
		dislikelistEntry?: Maybe<TitleListEntry>;
		/** The entries in the user's customlists. */
		customlistEntries: Array<TitleListEntry>;
		/**
		 * A list of similar titles. Not specific to the user, returning the same for all users.
		 * @deprecated Use the V2 :)
		 */
		similarTitles: Array<MovieOrShow>;
		/** A list of similar titles. Not specific to the user, returning the same for all users. */
		similarTitlesV2: SimilarTitlesConnection;
		/** A list of permanent audience IDs the title is part of. */
		permanentAudiences: Array<Scalars['String']>;
		/** The popularity rank and its trend popularity behaviour for the given title and its neighbouring titles. */
		popularityRank: PopularityRank;
		/** The total number of existing seasons for this show. */
		totalSeasonCount: Scalars['Int'];
		/** The seasons included in this show. */
		seasons: Array<Season>;
		/** All the episodes included in this show. */
		episodes: Array<Episode>;
		/** Returns the Watch Next episode: the first unseen episode following the last seen episode (by timestamp). */
		watchNextEpisode?: Maybe<Episode>;
		/**
		 * For shows, knowing what is seen is a bit more complicated since the seen data is stored at the episode level.
		 * So we calculate it based on the episodes.
		 */
		seenState: ShowSeenState;
	};

/** Personalized show aggregating user data and static Content data. */
export type ShowAvailableToArgs = {
	country: Scalars['Country'];
	platform: Platform;
	packages?: Maybe<Array<Scalars['String']>>;
};

/** Personalized show aggregating user data and static Content data. */
export type ShowContentArgs = {
	country: Scalars['Country'];
	language: Scalars['Language'];
};

/** Personalized show aggregating user data and static Content data. */
export type ShowOffersArgs = {
	country: Scalars['Country'];
	platform: Platform;
	filter?: OfferFilter;
};

/** Personalized show aggregating user data and static Content data. */
export type ShowOfferCountArgs = {
	country: Scalars['Country'];
	platform: Platform;
	filter?: OfferFilter;
	distinctPackages?: Scalars['Boolean'];
};

/** Personalized show aggregating user data and static Content data. */
export type ShowPromotedOffersArgs = {
	country: Scalars['Country'];
	platform: Platform;
	filter?: OfferFilter;
};

/** Personalized show aggregating user data and static Content data. */
export type ShowPromotedBundlesArgs = {
	country: Scalars['Country'];
	platform: Platform;
	filter?: OfferFilter;
};

/** Personalized show aggregating user data and static Content data. */
export type ShowWatchNowOfferArgs = {
	country: Scalars['Country'];
	platform: Platform;
	filter?: WatchNowOfferFilter;
};

/** Personalized show aggregating user data and static Content data. */
export type ShowSimilarTitlesArgs = {
	country: Scalars['Country'];
	filter?: Maybe<TitleFilter>;
	limit?: Scalars['Int'];
};

/** Personalized show aggregating user data and static Content data. */
export type ShowSimilarTitlesV2Args = {
	country: Scalars['Country'];
	filter?: Maybe<TitleFilter>;
	first?: Scalars['Int'];
	allowSponsoredRecommendations?: Maybe<SponsoredRecommendationsInput>;
};

/** Personalized show aggregating user data and static Content data. */
export type ShowPopularityRankArgs = {
	country: Scalars['Country'];
	previousTitles?: Scalars['Int'];
	nextTitles?: Scalars['Int'];
	category?: PopularityRankTypes;
};

/** Personalized show aggregating user data and static Content data. */
export type ShowSeasonsArgs = {
	releasedInCountry?: Maybe<Scalars['Country']>;
	sortDirection?: SortDirection;
	limit?: Maybe<Scalars['Int']>;
};

/** Personalized show aggregating user data and static Content data. */
export type ShowEpisodesArgs = {
	releasedInCountry?: Maybe<Scalars['Country']>;
	sortDirection?: SortDirection;
	limit?: Maybe<Scalars['Int']>;
};

/** Personalized show aggregating user data and static Content data. */
export type ShowWatchNextEpisodeArgs = {
	country: Scalars['Country'];
	includeUnreleasedEpisodes?: Scalars['Boolean'];
};

/** Personalized show aggregating user data and static Content data. */
export type ShowSeenStateArgs = {
	country: Scalars['Country'];
};

/** Unpersonalized show data common to all the users, as defined by Content. It is localized by country and language. */
export type ShowContent = MovieOrShowContent &
	MovieOrShowOrSeasonContent &
	MovieOrShowOrSeasonOrEpisodeContent & {
		__typename?: 'ShowContent';
		/** The original title of the title. */
		originalTitle: Scalars['String'];
		/** The localized title of the title. Depends on the language being set. */
		title: Scalars['String'];
		/** A short description of the title. */
		shortDescription?: Maybe<Scalars['String']>;
		/** The duration of the title. For shows and seasons, it's the average runtime of an episode. */
		runtime?: Maybe<Scalars['Int']>;
		/** The year when the title was originally first released. */
		originalReleaseYear?: Maybe<Scalars['Int']>;
		/** The date when the title was originally first released. */
		originalReleaseDate?: Maybe<Scalars['Date']>;
		/** The date when the title was first released in the country. */
		localizedReleaseDate?: Maybe<Scalars['Date']>;
		/** Whether we consider the title as released or not. */
		isReleased: Scalars['Boolean'];
		/** The title upcoming releases on streaming or cinema. Sorted by release date. */
		upcomingReleases: Array<UpcomingRelease>;
		/**
		 * The localized website detail page URL of the title. Depends on the country being set.
		 *
		 * e.g. '/us/movie/batman-the-dark-knight'
		 */
		fullPath: Scalars['String'];
		/** The related genre objects. */
		genres: Array<Genre>;
		/** The trailers/clips attached to the title. */
		clips: Array<Clip>;
		/** The countries where the title was produced. */
		productionCountries: Array<Scalars['Country']>;
		/**
		 * The localized poster URL. Depends on the country and language being set.
		 * It takes a desired size (called profile) and desired format as parameter.
		 *
		 * e.g. 's166' + 'webp' -> '/poster/8711516/s166/memento.webp'
		 */
		posterUrl?: Maybe<Scalars['String']>;
		/**
		 * The blur hash representation of the poster.
		 *
		 * Generated using https://github.com/woltapp/blurhash.
		 */
		posterBlurHash?: Maybe<Scalars['String']>;
		/**
		 * A list of backdrops. It takes a desired size (called profile) and desired format as parameter.
		 *
		 * e.g. 's1440' + 'webp' -> '/backdrop/8711516/s1440/Spider-Man-Homecoming.webp'
		 */
		backdrops: Array<Backdrop>;
		/** All the scorings/ratings of the title. */
		scoring: Scoring;
		/** All the IDs of the title on external platforms. */
		externalIds: ExternalIds;
		/** The credits of the title. The 'personId' filter can be used to check if a certain person was involved in the title. */
		credits: Array<Credit>;
		/** The age rating. e.g. PG-13 for movies, TV-PG for shows in the US */
		ageCertification?: Maybe<Scalars['String']>;
	};

/** Unpersonalized show data common to all the users, as defined by Content. It is localized by country and language. */
export type ShowContentUpcomingReleasesArgs = {
	releaseTypes?: Maybe<Array<ReleaseType>>;
	packages?: Maybe<Array<Scalars['String']>>;
};

/** Unpersonalized show data common to all the users, as defined by Content. It is localized by country and language. */
export type ShowContentClipsArgs = {
	providers?: Maybe<Array<ClipProvider>>;
};

/** Unpersonalized show data common to all the users, as defined by Content. It is localized by country and language. */
export type ShowContentPosterUrlArgs = {
	profile?: Maybe<PosterProfile>;
	format?: Maybe<ImageFormat>;
};

/** Unpersonalized show data common to all the users, as defined by Content. It is localized by country and language. */
export type ShowContentBackdropsArgs = {
	profile?: Maybe<BackdropProfile>;
	format?: Maybe<ImageFormat>;
};

/** Unpersonalized show data common to all the users, as defined by Content. It is localized by country and language. */
export type ShowContentCreditsArgs = {
	first?: Maybe<Scalars['Int']>;
	role?: Maybe<CreditRole>;
	personId?: Maybe<Scalars['Int']>;
};

/**
 * An aggregation of the seen state of a show/season.
 *
 * It is built out of seen episodes.
 */
export type ShowSeenState = {
	__typename?: 'ShowSeenState';
	/** The time of the last episode entry creation. */
	lastCreatedAt?: Maybe<Scalars['Time']>;
	/** The episode number of the last episode entry creation. */
	lastSeenEpisodeNumber?: Maybe<Scalars['Int']>;
	/** The season number of the last episode entry creation. */
	lastSeenSeasonNumber?: Maybe<Scalars['Int']>;
	/** True when the last released episode is seen. */
	caughtUp: Scalars['Boolean'];
	/** A count of all the seen episodes. */
	seenEpisodeCount: Scalars['Int'];
	/** A count of all released episodes. */
	releasedEpisodeCount: Scalars['Int'];
	/** A progress bar between 0 and 100. */
	progress: Scalars['Int'];
};

/** A connection object for similar titles. */
export type SimilarTitlesConnection = {
	__typename?: 'SimilarTitlesConnection';
	/** Indicates if a sponsored recommendation is currently active for the user. */
	activeCampaign?: Maybe<SponsoredRecommendationCampaign>;
	/** The edges for each of the items. */
	edges?: Maybe<Array<SimilarTitlesEdge>>;
};

/** An edge object for similar titles. */
export type SimilarTitlesEdge = {
	__typename?: 'SimilarTitlesEdge';
	/** The node represented by this edge. */
	node: MovieOrShow;
};

/** One result/competitor for single step sports (tennis, football, handball, basketball...). */
export type SingleStepSportCompetitorV2 = {
	__typename?: 'SingleStepSportCompetitorV2';
	/** The competitor for a team sport. */
	competitors: Array<SportCompetitorV2>;
	/** The score that the team has. */
	score?: Maybe<Scalars['Int']>;
	/** If the team won. */
	winner: Scalars['Boolean'];
};

/** The result/competitors for single step sports (tennis, football, handball, basketball...). */
export type SingleStepSportCompetitorsV2 = {
	__typename?: 'SingleStepSportCompetitorsV2';
	/** The home team. */
	homeTeam: SingleStepSportCompetitorV2;
	/** The away team. */
	awayTeam: SingleStepSportCompetitorV2;
};

/** A single step sport match. */
export type SingleStepSportEvent = SportEventV2 &
	SportTitle &
	Node & {
		__typename?: 'SingleStepSportEvent';
		/** The global node ID. */
		id: Scalars['ID'];
		/** The Content type of the title. */
		objectType: ObjectType;
		/** The Content ID of the title. */
		objectId: Scalars['Int'];
		/** The sport of the event. */
		sport: SportType;
		/** The sport event data. It is localized by language. */
		content: SingleStepSportEventContent;
		/** The offers for the sport event. */
		offers: Array<SportOffer>;
		/** The offer count available on packages for the event. Depends on the country being set.  */
		offerCount: Scalars['Int'];
		/** The default offer that should be used to play the event. Can be null if there are no matching offers. */
		watchNowOffer?: Maybe<SportOffer>;
		/** The competition the event belongs to. */
		competition?: Maybe<SportCompetitionV2>;
		/** The entry for the sport event in the my sport list. */
		mysportlistEntry?: Maybe<TitleListEntry>;
		competitors: SingleStepSportCompetitorsV2;
	};

/** A single step sport match. */
export type SingleStepSportEventContentArgs = {
	country: Scalars['Country'];
	language: Scalars['Language'];
};

/** A single step sport match. */
export type SingleStepSportEventOffersArgs = {
	country: Scalars['Country'];
	platform: Platform;
	filter?: SportOfferFilter;
};

/** A single step sport match. */
export type SingleStepSportEventOfferCountArgs = {
	country: Scalars['Country'];
	platform: Platform;
	filter?: SportOfferFilter;
};

/** A single step sport match. */
export type SingleStepSportEventWatchNowOfferArgs = {
	country: Scalars['Country'];
	platform: Platform;
	filter?: WatchNowSportOfferFilter;
};

/** A single step sport match information. */
export type SingleStepSportEventContent = SportEventContentV2 & {
	__typename?: 'SingleStepSportEventContent';
	/** A localized name for the match */
	name: Scalars['String'];
	/** General status of the event */
	status: SportEventStatus;
	/** When the event starts */
	startAt: Scalars['Time'];
	/** When the event ends */
	endAt?: Maybe<Scalars['Time']>;
	/** The venue where the event was held */
	venue?: Maybe<SportVenue>;
	/** The competition season during which the event took place */
	season?: Maybe<SportSeason>;
	/**
	 * A list of backdrops. It takes a desired size (called profile) and desired format as parameter.
	 *
	 * e.g. 's1440' + 'webp' -> '/backdrop/8711516/s1440/Spider-Man-Homecoming.webp'
	 */
	backdrops: Array<Backdrop>;
	/**
	 * The localized website detail page URL of the sport event. Depends on the country being set.
	 *
	 * e.g. '/de/fussball/La-Liga/FC-Barcelona-Real-Madrid-2021-2022'
	 */
	fullPath?: Maybe<Scalars['String']>;
	/** The stage of the competition the event is in. */
	competitionStage: SportCompetitionStageV2;
};

/** A single step sport match information. */
export type SingleStepSportEventContentBackdropsArgs = {
	profile?: Maybe<BackdropProfile>;
	format?: Maybe<ImageFormat>;
};

/** In which direction we should sort a list. */
export enum SortDirection {
	/** Ascending */
	Asc = 'ASC',
	/** Descending */
	Desc = 'DESC',
}

/** A sponsored module is a module linked to an active sponsored recommendation campaign. */
export type SponsoredModule = {
	__typename?: 'SponsoredModule';
	/** Indicates the sponsored recommendation currently active for the user. */
	activeCampaign: SponsoredRecommendationCampaign;
	module: Module;
};

/** Represents a sponsored recommendation campaign running on JustWatch. */
export type SponsoredRecommendationCampaign = {
	__typename?: 'SponsoredRecommendationCampaign';
	/** The node we're promoting. */
	node: Node;
	/** The watch now offer override, hardcoded for the campaign. */
	watchNowOffer: Offer;
	/** The watch now label override, hardcoded for the campaign. */
	watchNowLabel?: Maybe<Scalars['String']>;
	/** The image override, hardcoded for the campaign. It's an absolute URL. */
	promotionalImageUrl?: Maybe<Scalars['String']>;
	/** Whether the JW/IMDB ratings should be hidden from the user. */
	hideRatings: Scalars['Boolean'];
	/** A list of external impression tracker URLs. */
	externalImpressionTrackers: Array<Scalars['String']>;
};

/** The input used to know which campaigns are currently active for the user. */
export type SponsoredRecommendationsInput = {
	/** The country of the user. */
	country: Scalars['Country'];
	/** The platform of the user. */
	platform: Platform;
};

/** A sport. */
export type Sport = {
	__typename?: 'Sport';
	/** The type of the sport. */
	type: SportType;
};

/** A sport competition content, common to all the sports. */
export type SportCompetitionContentV2 = {
	__typename?: 'SportCompetitionContentV2';
	/** The localized name of the competition */
	name: Scalars['String'];
	/**
	 * A list of backdrops. It takes a desired size (called profile) and desired format as parameter.
	 *
	 * e.g. 's1440' + 'webp' -> '/backdrop/8711516/s1440/Spider-Man-Homecoming.webp'
	 */
	backdrops: Array<Backdrop>;
	/**
	 * The localized logo URL. Depends on the country and language being set.
	 * It takes a desired size (called profile) and desired format as parameter.
	 *
	 * e.g. 's166' + 'webp' -> '/logo/8711516/s166/memento.webp'
	 */
	iconUrl?: Maybe<Scalars['String']>;
	/**
	 * The blur hash representation of the logo.
	 *
	 * Generated using https://github.com/woltapp/blurhash.
	 */
	iconBlurHash?: Maybe<Scalars['String']>;
	/**
	 * The localized website detail page URL of the sport competition. Depends on the country being set.
	 *
	 * e.g. '/de/fussball/Bundesliga'
	 */
	fullPath: Scalars['String'];
};

/** A sport competition content, common to all the sports. */
export type SportCompetitionContentV2BackdropsArgs = {
	profile?: Maybe<BackdropProfile>;
	format?: Maybe<ImageFormat>;
};

/** A sport competition content, common to all the sports. */
export type SportCompetitionContentV2IconUrlArgs = {
	profile?: Maybe<IconProfile>;
	format?: Maybe<ImageFormat>;
};

export enum SportCompetitionStageName {
	/** All sports */
	Undefined = 'UNDEFINED',
	MatchDay = 'MATCH_DAY',
	/** Tennis and Football */
	Final = 'FINAL',
	Semifinal = 'SEMIFINAL',
	Quarterfinal = 'QUARTERFINAL',
	RoundOf_8 = 'ROUND_OF_8',
	RoundOf_16 = 'ROUND_OF_16',
	RoundOf_32 = 'ROUND_OF_32',
	RoundOf_64 = 'ROUND_OF_64',
	RoundOf_128 = 'ROUND_OF_128',
	QualificationFinal = 'QUALIFICATION_FINAL',
	QualificationRound_2 = 'QUALIFICATION_ROUND_2',
	QualificationRound_1 = 'QUALIFICATION_ROUND_1',
	Qualification = 'QUALIFICATION',
	PlayoffRound = 'PLAYOFF_ROUND',
	/** Formula racing */
	Race = 'RACE',
	Qualifying = 'QUALIFYING',
	Practice = 'PRACTICE',
	Sprint = 'SPRINT',
	/** American football */
	AmericanFootballConferenceChampionship = 'AMERICAN_FOOTBALL_CONFERENCE_CHAMPIONSHIP',
	AmericanFootballConferenceDivisionalRound = 'AMERICAN_FOOTBALL_CONFERENCE_DIVISIONAL_ROUND',
	AmericanFootballConferenceWildCardRound = 'AMERICAN_FOOTBALL_CONFERENCE_WILD_CARD_ROUND',
	NationalFootballConferenceChampionship = 'NATIONAL_FOOTBALL_CONFERENCE_CHAMPIONSHIP',
	NationalFootballConferenceDivisionalRound = 'NATIONAL_FOOTBALL_CONFERENCE_DIVISIONAL_ROUND',
	NationalFootballConferenceWildCardRound = 'NATIONAL_FOOTBALL_CONFERENCE_WILD_CARD_ROUND',
	SuperBowl = 'SUPER_BOWL',
}

/** The stage of a sport competition. */
export type SportCompetitionStageV2 = {
	__typename?: 'SportCompetitionStageV2';
	/** The name of the stage. */
	name: SportCompetitionStageName;
	/** The number of the stage. */
	number?: Maybe<Scalars['Int']>;
};

/** A sport competition, common to all the sports. */
export type SportCompetitionV2 = SportTitle &
	Node & {
		__typename?: 'SportCompetitionV2';
		/** The global node ID. */
		id: Scalars['ID'];
		/** The Content type of the title. */
		objectType: ObjectType;
		/** The Content ID of the title. */
		objectId: Scalars['Int'];
		/** The sport of the competition. */
		sport: SportType;
		/** The sport competition data. It is localized by language. */
		content: SportCompetitionContentV2;
		/** The current or upcoming season of the competition. */
		activeSeason?: Maybe<SportSeason>;
		/** Runs a sport event search and returns an aggregated list of sport events for the given competition. */
		sportEventBucketsV2: SportEventBucketsConnectionV2;
		/** Runs a sport event search for the given competition. */
		sportEventsV2: SportEventsConnectionV2;
	};

/** A sport competition, common to all the sports. */
export type SportCompetitionV2ContentArgs = {
	country: Scalars['Country'];
	language: Scalars['Language'];
};

/** A sport competition, common to all the sports. */
export type SportCompetitionV2ActiveSeasonArgs = {
	country: Scalars['Country'];
	language: Scalars['Language'];
};

/** A sport competition, common to all the sports. */
export type SportCompetitionV2SportEventBucketsV2Args = {
	country: Scalars['Country'];
	first?: Scalars['Int'];
	after?: Maybe<Scalars['String']>;
	bucketSize?: Maybe<Scalars['Int']>;
	filter?: Maybe<SportEventFilter>;
	groupBy: SportEventAggregation;
	timezoneOffset: Scalars['Int'];
};

/** A sport competition, common to all the sports. */
export type SportCompetitionV2SportEventsV2Args = {
	country: Scalars['Country'];
	first?: Scalars['Int'];
	after?: Maybe<Scalars['String']>;
	filter?: Maybe<SportEventFilter>;
	timezoneOffset: Scalars['Int'];
};

/** A connection object for the sport event buckets. */
export type SportCompetitionsConnectionV2 = {
	__typename?: 'SportCompetitionsConnectionV2';
	/** The total number of items. */
	totalCount: Scalars['Int'];
	/** The edges for each of the buckets. */
	edges?: Maybe<Array<SportCompetitionsEdgeV2>>;
	/** Information for paginating this connection. */
	pageInfo: PageInfo;
};

/** An edge object for the sport event buckets. */
export type SportCompetitionsEdgeV2 = {
	__typename?: 'SportCompetitionsEdgeV2';
	/** A cursor used for pagination. */
	cursor: Scalars['String'];
	/** The node represented by this edge. */
	node: SportCompetitionV2;
};

/** A sport competitor content, common to all the sports. */
export type SportCompetitorContentV2 = {
	__typename?: 'SportCompetitorContentV2';
	/** The localized name of the competitor. */
	name: Scalars['String'];
	/** The localized first name of the competitor. */
	firstName: Scalars['String'];
	/** The localized last name of the competitor. */
	lastName: Scalars['String'];
	/** A localized short description of the competitor. */
	shortDescription: Scalars['String'];
	/**
	 * The localized logo URL. Depends on the country and language being set.
	 * It takes a desired size (called profile) and desired format as parameter.
	 *
	 * e.g. 's166' + 'webp' -> '/logo/8711516/s166/memento.webp'
	 */
	iconUrl?: Maybe<Scalars['String']>;
	/**
	 * The blur hash representation of the logo.
	 *
	 * Generated using https://github.com/woltapp/blurhash.
	 */
	iconBlurHash?: Maybe<Scalars['String']>;
	/**
	 * The localized website detail page URL of the sport competitor. Depends on the country being set.
	 *
	 * e.g. '/de/fussball/Bayern-München'
	 */
	fullPath: Scalars['String'];
};

/** A sport competitor content, common to all the sports. */
export type SportCompetitorContentV2IconUrlArgs = {
	profile?: Maybe<IconProfile>;
	format?: Maybe<ImageFormat>;
};

/** A sport competitor, common to all the sports. */
export type SportCompetitorV2 = SportTitle &
	Node & {
		__typename?: 'SportCompetitorV2';
		/** The global node ID. */
		id: Scalars['ID'];
		/** The Content type of the title. */
		objectType: ObjectType;
		/** The Content ID of the title. */
		objectId: Scalars['Int'];
		/** The sport of the competition. */
		sport: SportType;
		/** The sport competitor data. It is localized by language. */
		content: SportCompetitorContentV2;
		/** The competitor children. */
		children: Array<SportCompetitorV2>;
		/** Runs a sport event search and returns an aggregated list of sport events for the given competition. */
		sportEventBucketsV2: SportEventBucketsConnectionV2;
		/** Runs a sport event search for the given competition. */
		sportEventsV2: SportEventsConnectionV2;
	};

/** A sport competitor, common to all the sports. */
export type SportCompetitorV2ContentArgs = {
	country: Scalars['Country'];
	language: Scalars['Language'];
};

/** A sport competitor, common to all the sports. */
export type SportCompetitorV2SportEventBucketsV2Args = {
	country: Scalars['Country'];
	first?: Scalars['Int'];
	after?: Maybe<Scalars['String']>;
	bucketSize?: Maybe<Scalars['Int']>;
	filter?: Maybe<SportEventFilter>;
	groupBy: SportEventAggregation;
	timezoneOffset: Scalars['Int'];
};

/** A sport competitor, common to all the sports. */
export type SportCompetitorV2SportEventsV2Args = {
	country: Scalars['Country'];
	first?: Scalars['Int'];
	after?: Maybe<Scalars['String']>;
	filter?: Maybe<SportEventFilter>;
	timezoneOffset: Scalars['Int'];
};

/** The different ways of aggregating the sport events. */
export enum SportEventAggregation {
	/** We aggregate by sport. */
	Sport = 'SPORT',
	/** We aggregate by competition. */
	Competition = 'COMPETITION',
	/** We aggregate by date + competition. New timeline style. */
	DateCompetition = 'DATE_COMPETITION',
	/** We aggregate by competition stage. */
	CompetitionStage = 'COMPETITION_STAGE',
	/** We aggregate by sport event parent. */
	Parent = 'PARENT',
}

/** A list of the possible aggregation keys being returned, depending on the aggregation type. */
export type SportEventAggregationKeyV2 = {
	__typename?: 'SportEventAggregationKeyV2';
	sport?: Maybe<Sport>;
	startAtDate?: Maybe<Scalars['Date']>;
	competition?: Maybe<SportCompetitionV2>;
	competitionStage?: Maybe<SportCompetitionStageV2>;
	parent?: Maybe<SportEventV2>;
};

/** A connection object for the sport event buckets. */
export type SportEventBucketsConnectionV2 = {
	__typename?: 'SportEventBucketsConnectionV2';
	/** The edges for each of the buckets. */
	edges?: Maybe<Array<SportEventBucketsEdgeV2>>;
	/** Information for paginating this connection. */
	pageInfo: PageInfo;
};

/** An edge object for the sport event buckets. */
export type SportEventBucketsEdgeV2 = {
	__typename?: 'SportEventBucketsEdgeV2';
	/** A cursor used for pagination. */
	cursor: Scalars['String'];
	/** The bucket aggregation key. */
	key: SportEventAggregationKeyV2;
	/** The node represented by this edge. */
	node: SportEventsConnectionV2;
};

/** Generic interface for a sport event content, common to all the sports. */
export type SportEventContentV2 = {
	/** A localized name for the match */
	name: Scalars['String'];
	/** General status of the event */
	status: SportEventStatus;
	/** When the event starts */
	startAt: Scalars['Time'];
	/** When the event ends */
	endAt?: Maybe<Scalars['Time']>;
	/** The venue where the event was held */
	venue?: Maybe<SportVenue>;
	/** The competition season during which the event took place */
	season?: Maybe<SportSeason>;
	/**
	 * A list of backdrops. It takes a desired size (called profile) and desired format as parameter.
	 *
	 * e.g. 's1440' + 'webp' -> '/backdrop/8711516/s1440/Spider-Man-Homecoming.webp'
	 */
	backdrops: Array<Backdrop>;
	/**
	 * The localized website detail page URL of the sport event. Depends on the country being set.
	 *
	 * e.g. '/de/fussball/La-Liga/FC-Barcelona-Real-Madrid-2021-2022'
	 */
	fullPath?: Maybe<Scalars['String']>;
	/** The stage of the competition the event is in. */
	competitionStage: SportCompetitionStageV2;
};

/** Generic interface for a sport event content, common to all the sports. */
export type SportEventContentV2BackdropsArgs = {
	profile?: Maybe<BackdropProfile>;
	format?: Maybe<ImageFormat>;
};

/** The main sport event filter. */
export type SportEventFilter = {
	/** Keep only the events having an offer with the given packages. Short names are expected (e.g. 'nfx' for Netflix). */
	packages?: Maybe<Array<Scalars['String']>>;
	/** Keep only the events starting over the given timeframe. Only returning the upcoming events by default. */
	startAt?: Maybe<TimeFilter>;
	/** Keep only the events for the given sports. */
	sports?: Maybe<Array<SportType>>;
	/** Keep only the events for the given competition ids (e.g. 'scn-foo-56'). */
	competitionIds?: Maybe<Array<Scalars['ID']>>;
	/** Keep only the events for the given competitor ids (e.g. 'scr-foo-32'). */
	competitorIds?: Maybe<Array<Scalars['ID']>>;
	/** Keep only the events having the given parent ids (e.g. 'scn-foo-56').. */
	parentIds?: Maybe<Array<Scalars['ID']>>;
	/** Keep only the events for the given competition stage names. */
	competitionStageNames?: Maybe<Array<SportCompetitionStageName>>;
	/** When filtering by 'MATCH_DAY' football round for example, keep only the events for the given match day numbers. */
	competitionStageNumbers?: Maybe<Array<Scalars['Int']>>;
	/** Keep only the given sport event ids (e.g. 'se-foo-33'). */
	eventIds?: Maybe<Array<Scalars['ID']>>;
};

/** The different possible matrix responses. */
export type SportEventMatrix = SportEventMatrixPackageColumns | SportEventMatrixCompetitionColumns;

/** The different ways of aggregating the sport events. */
export enum SportEventMatrixAggregation {
	/** We aggregate by competition + by package. */
	CompetitionPackage = 'COMPETITION_PACKAGE',
	/** We aggregate by package + by competition. */
	PackageCompetition = 'PACKAGE_COMPETITION',
}

/** A column of the matrix for the COMPETITION_PACKAGE aggregation. */
export type SportEventMatrixCompetitionColumn = {
	__typename?: 'SportEventMatrixCompetitionColumn';
	/** The competition of the column. */
	competition: SportCompetitionV2;
	/** The count of unique sport events for this column. */
	count: Scalars['Int'];
	/** The package rows per competition. */
	packages: Array<SportEventMatrixPackageRow>;
};

/** The columns for the COMPETITION_PACKAGE aggregation. */
export type SportEventMatrixCompetitionColumns = {
	__typename?: 'SportEventMatrixCompetitionColumns';
	/** The competition columns. */
	competitions: Array<SportEventMatrixCompetitionColumn>;
};

/** A row of the matrix for the PACKAGE_COMPETITION aggregation. */
export type SportEventMatrixCompetitionRow = {
	__typename?: 'SportEventMatrixCompetitionRow';
	/** The competition of the row. */
	competition: SportCompetitionV2;
	/** The count of unique sport events for this row. */
	count: Scalars['Int'];
};

/** A column of the matrix for the PACKAGE_COMPETITION aggregation. */
export type SportEventMatrixPackageColumn = {
	__typename?: 'SportEventMatrixPackageColumn';
	/** The package of the column. */
	package: Package;
	/** The count of unique sport events for this column. */
	count: Scalars['Int'];
	/** The competition rows per package. */
	competitions: Array<SportEventMatrixCompetitionRow>;
};

/** The columns for the PACKAGE_COMPETITION aggregation. */
export type SportEventMatrixPackageColumns = {
	__typename?: 'SportEventMatrixPackageColumns';
	/** The package columns. */
	packages: Array<SportEventMatrixPackageColumn>;
};

/** A row of the matrix for the COMPETITION_PACKAGE aggregation. */
export type SportEventMatrixPackageRow = {
	__typename?: 'SportEventMatrixPackageRow';
	/** The package of the row. */
	package: Package;
	/** The count of unique sport events for this row. */
	count: Scalars['Int'];
};

/** Defines the possible statuses of a sport event. */
export enum SportEventStatus {
	/** The match is scheduled to be played */
	NotStarted = 'NOT_STARTED',
	/** The match has begun */
	Started = 'STARTED',
	/** The match is currently in progress */
	Live = 'LIVE',
	/** The match has been postponed to a future date */
	Postponed = 'POSTPONED',
	/** The match has been suspended */
	Suspended = 'SUSPENDED',
	/** The match is about to begin */
	MatchAboutToStart = 'MATCH_ABOUT_TO_START',
	/** The match has been temporarily delayed and will be continued */
	Delayed = 'DELAYED',
	/** The match began, but coverage has stopped for a short time. Note that match scores may not be updated during this period, the last recorded match score will be displayed instead */
	Interrupted = 'INTERRUPTED',
	/** The match has been cancelled and will not be played */
	Cancelled = 'CANCELLED',
	/** The match is over */
	Ended = 'ENDED',
	/** The match results have been confirmed */
	Closed = 'CLOSED',
}

/** Generic interface for a sport event, common to all the sports. */
export type SportEventV2 = {
	/** Node Id of the event. */
	id: Scalars['ID'];
	/** The Content type of the title. */
	objectType: ObjectType;
	/** The Content ID of the title. */
	objectId: Scalars['Int'];
	/** The sport of the event. */
	sport: SportType;
	/** The sport event data. It is localized by language. */
	content: SportEventContentV2;
	/** The offers for the sport event. */
	offers: Array<SportOffer>;
	/** The offer count available on packages for the event. Depends on the country being set.  */
	offerCount: Scalars['Int'];
	/** The default offer that should be used to play the event. Can be null if there are no matching offers. */
	watchNowOffer?: Maybe<SportOffer>;
	/** The competition the event belongs to. */
	competition?: Maybe<SportCompetitionV2>;
	/** The entry for the sport event in the my sport list. */
	mysportlistEntry?: Maybe<TitleListEntry>;
};

/** Generic interface for a sport event, common to all the sports. */
export type SportEventV2ContentArgs = {
	country: Scalars['Country'];
	language: Scalars['Language'];
};

/** Generic interface for a sport event, common to all the sports. */
export type SportEventV2OffersArgs = {
	country: Scalars['Country'];
	platform: Platform;
	filter?: SportOfferFilter;
};

/** Generic interface for a sport event, common to all the sports. */
export type SportEventV2OfferCountArgs = {
	country: Scalars['Country'];
	platform: Platform;
	filter?: SportOfferFilter;
};

/** Generic interface for a sport event, common to all the sports. */
export type SportEventV2WatchNowOfferArgs = {
	country: Scalars['Country'];
	platform: Platform;
	filter?: WatchNowSportOfferFilter;
};

/** A connection object for the sport events. */
export type SportEventsConnectionV2 = {
	__typename?: 'SportEventsConnectionV2';
	/** The total number of items. */
	totalCount: Scalars['Int'];
	/** The edges for each of the items. */
	edges?: Maybe<Array<SportEventsEdgeV2>>;
	/** Information for paginating this connection. */
	pageInfo: PageInfo;
};

/** An edge object for the sport events. */
export type SportEventsEdgeV2 = {
	__typename?: 'SportEventsEdgeV2';
	/** A cursor used for pagination. */
	cursor: Scalars['String'];
	/** The node represented by this edge. */
	node: SportEventV2;
};

/** The type of a Sport object. */
export enum SportObjectType {
	/** A full sport event */
	MainEvent = 'MAIN_EVENT',
	/** Highlights of a sport event */
	Highlight = 'HIGHLIGHT',
	/** An interview related to a sport event */
	Interview = 'INTERVIEW',
}

/** Defines the offering of a package for a certain Content sport event. Unique key is (jwEntityID, country, packageId, monetizationType, presentationType, sportObjectType). */
export type SportOffer = {
	__typename?: 'SportOffer';
	/** The related package object. */
	package: Package;
	/** The user's country */
	country: Scalars['Country'];
	/** The monetization of the offer. */
	monetizationType: MonetizationType;
	/** The presentation format of the offer. */
	presentationType: PresentationType;
	/** The type of content contained in the offer */
	sportObjectType: SportObjectType;
	/** The date where the title becomes available on the provider. */
	availableFrom?: Maybe<Scalars['Time']>;
	/** The date where the title is leaving the provider. */
	availableTo?: Maybe<Scalars['Time']>;
	/** The raw price of the offer (monetization type BUY/RENT). */
	retailPrice?: Maybe<Scalars['Float']>;
	/** The raw price of the offer (monetization type BUY/RENT). */
	retailPriceValue?: Maybe<Scalars['Float']>;
	/** The pricings currency. */
	currency?: Maybe<Scalars['String']>;
	/** Website URL of the offer page. */
	standardWebURL?: Maybe<Scalars['String']>;
	/** Deeplink URL directly playing an offer. */
	deeplinkURL?: Maybe<Scalars['String']>;
	/**
	 * Language when language specific stream offers are available.
	 * @deprecated Please use the 'audioLanguage' field
	 */
	audioLanguages?: Maybe<Array<Scalars['String']>>;
	/** Language when language specific stream offers are available. */
	audioLanguage?: Maybe<Scalars['String']>;
	/**
	 * subTitle language filter when subtitle in multiple languages are available
	 * @deprecated Please use the 'subtitleLanguage' field
	 */
	subtitleLanguages?: Maybe<Array<Scalars['String']>>;
	/** subTitle language filter when subtitle in multiple languages are available */
	subtitleLanguage?: Maybe<Scalars['String']>;
};

/** Defines the offering of a package for a certain Content sport event. Unique key is (jwEntityID, country, packageId, monetizationType, presentationType, sportObjectType). */
export type SportOfferRetailPriceArgs = {
	language: Scalars['Language'];
};

/** Defines the offering of a package for a certain Content sport event. Unique key is (jwEntityID, country, packageId, monetizationType, presentationType, sportObjectType). */
export type SportOfferDeeplinkUrlArgs = {
	platform: Platform;
};

/** This filter allows filtering of a list of offers. */
export type SportOfferFilter = {
	/** Only keep the best offer per package. */
	bestOnly?: Maybe<Scalars['Boolean']>;
	/** Keep only the offers having the given packages. Short names are expected (e.g. 'nfx' for Netflix). */
	packages?: Maybe<Array<Scalars['String']>>;
};

/** A particular season for a sport competition. */
export type SportSeason = {
	__typename?: 'SportSeason';
	/** ID of the season */
	seasonID: Scalars['Int'];
	/** The localized name of the season */
	name: Scalars['String'];
};

/** Generic interface shared between all the sport entities. */
export type SportTitle = {
	/**
	 * The global node ID of the title. For titles, it is defined by Content and made from object type + object ID.
	 *
	 * e.g. 'se-foo-21' -> 'sport_event' + 'football' + 21
	 */
	id: Scalars['ID'];
	/** The Content type of the title. */
	objectType: ObjectType;
	/** The Content ID of the title. */
	objectId: Scalars['Int'];
	/** The sport of the competition. */
	sport: SportType;
};

/** The different sports being supported. */
export enum SportType {
	/** That's the real football one. */
	Football = 'FOOTBALL',
	/** All the Formula 1, 2, 3 stuff. */
	FormulaRacing = 'FORMULA_RACING',
	/** People exchanging a yellow ball. */
	Tennis = 'TENNIS',
	/** Not the foot-on-ball. */
	AmericanFootball = 'AMERICAN_FOOTBALL',
	/** The bat and ball sport. */
	Baseball = 'BASEBALL',
	/** eSport: league of legends */
	EsportsLol = 'ESPORTS_LOL',
	/** Hockey on ice. */
	IceHockey = 'ICE_HOCKEY',
	/** Bouncing ball sport. */
	Basketball = 'BASKETBALL',
	/** A close contact team sport */
	Rugby = 'RUGBY',
	/** eSport: Dota2 */
	EsportsDota2 = 'ESPORTS_DOTA2',
	/** eSport: csgo */
	EsportsCsgo = 'ESPORTS_CSGO',
}

/** A sport venue (e.g. stadium, arena...). */
export type SportVenue = {
	__typename?: 'SportVenue';
	/** ID of the venue */
	venueID: Scalars['Int'];
	/** The localized name of the venue */
	name: Scalars['String'];
};

/** Indicates the user status for every platform. BI data. */
export type StatusPerPlatform = {
	__typename?: 'StatusPerPlatform';
	/** General user status. */
	total?: Maybe<UserStatus>;
	/** User status on web. */
	web?: Maybe<UserStatus>;
	/** User status on TV. */
	tv?: Maybe<UserStatus>;
	/** User status on mobile. */
	mob?: Maybe<UserStatus>;
};

/** The input needed to create a Stripe checkout session. */
export type StripeCheckoutSessionInput = {
	/** Stripe session ID */
	baseURL: Scalars['String'];
	/** Stripe product id based on the ab test variant. If not provided default gets chosen. */
	stripeProductID?: Maybe<Scalars['String']>;
};

/** The payload response of the Stripe checkout session. */
export type StripeCheckoutSessionPayload = {
	__typename?: 'StripeCheckoutSessionPayload';
	/** The checkout url received from Stripe. */
	checkoutURL: Scalars['String'];
};

/** The type of Stripe checkout session. */
export enum StripeCheckoutSessionStatus {
	/** Stripe checkout session is ongoing. */
	Open = 'OPEN',
	/** Stripe checkout session is completed. */
	Complete = 'COMPLETE',
	/** Stripe checkout session has expired. */
	Expired = 'EXPIRED',
}

/** The stripe checkout session query for payments. */
export type StripeCheckoutSessionStatusInput = {
	/** The Stripe checkout session id to be checked. */
	checkoutSessionId: Scalars['String'];
};

/** The status of Stripe checkout session.. */
export type StripeCheckoutSessionStatusType = {
	__typename?: 'StripeCheckoutSessionStatusType';
	/** The return type for checking the Stripe checkout session status. */
	status: StripeCheckoutSessionStatus;
};

/** The subscription root of JustWatch's GraphQL interface. */
export type Subscription = {
	__typename?: 'Subscription';
	/** Listens to a user settings change event stream coming from the same logged in account. */
	settingsReceived: Settings;
	/**
	 * Listens to a title play event stream coming from the same logged in account.
	 * @deprecated Name is now mandatory. Use the last version.
	 */
	playTitleReceived: MovieOrShowOrSeasonOrEpisode;
	/** Listens to a title play event stream coming from the same logged in account. */
	playTitleReceivedV2: MovieOrShowOrSeasonOrEpisode;
};

/** The subscription root of JustWatch's GraphQL interface. */
export type SubscriptionPlayTitleReceivedV2Args = {
	deviceName: Scalars['String'];
};

export enum TargetType {
	/** New Customlist */
	NewCustomlist = 'NEW_CUSTOMLIST',
	/** existing Customlist */
	ExistingCustomlist = 'EXISTING_CUSTOMLIST',
}

/** Generated list of taste survey titles based on the liked enitities input provided. */
export type TasteSurveyNextTitle = {
	__typename?: 'TasteSurveyNextTitle';
	/** List of title object related to the content for the display. */
	nextTitles: Array<MovieOrShow>;
	/** List of liked entity information submitted by the user. */
	likedJWEntityIDs?: Maybe<Array<Scalars['String']>>;
	/** Model version that was used to recommend the recommended titles. */
	modelVersion: Scalars['String'];
};

export type TasteSurveyResetPayload = {
	__typename?: 'TasteSurveyResetPayload';
	/** Current user session information best effort ID - user or device ID */
	bestEffortID: Scalars['String'];
};

/** The different subheadings possible on the edges of a watch next list. */
export enum TasteSurveyType {
	/** Legacy onboarding using a static json. */
	DivergingTitles = 'DIVERGING_TITLES',
	/** Legacy onboarding used for a gamified onboarding. */
	FinderGame = 'FINDER_GAME',
	/** Legacy onboarding used as a hack by the TV app to bypass the onboarding. */
	TvAppBlank = 'TV_APP_BLANK',
	/** Gefjon based onboarding, giving propositions based on the likes of the user and storing a temporary state in the user profile api. */
	AutoDigger = 'AUTO_DIGGER',
	/** Gefjon based onboarding, giving propositions based on the likes of the user, but stateless. */
	StaticDigger = 'STATIC_DIGGER',
	/** Gefjon based onboarding, giving static propositions based on what is displayed to the user. */
	StaticMappings = 'STATIC_MAPPINGS',
	/** Used when bypassing the onboarding altogether for our last version. */
	GlobalClickedCta = 'GLOBAL_CLICKED_CTA',
}

/** A Time range Title filter. . */
export type TimeFilter = {
	/** The from value. */
	from?: Maybe<Scalars['Time']>;
	/** The to value. */
	to?: Maybe<Scalars['Time']>;
};

/**
 * Personalized title aggregating user data and static Content data.
 *
 * This interface contains the fields that are common between all the different titles.
 */
export type Title = {
	/**
	 * The global node ID of the title. For titles, it is defined by Content and made from object type + object ID.
	 *
	 * e.g. 'tm21' -> 'movie' + 21, 'tss11' -> 'show_season' + 11
	 */
	id: Scalars['ID'];
	/** The Content type of the title. */
	objectType: ObjectType;
	/** The Content ID of the title. */
	objectId: Scalars['Int'];
};

/** The main title filter. */
export type TitleFilter = {
	/** Fuzzy search using the given query string. */
	searchQuery?: Maybe<Scalars['String']>;
	/** Keep only the titles having an offer with the given packages. Short names are expected (e.g. 'nfx' for Netflix). */
	packages?: Maybe<Array<Scalars['String']>>;
	/** If set to true, we will internally fetch and use the user settings packages. */
	useUserPackages?: Maybe<Scalars['Boolean']>;
	/** If set to true, irrelevant titles will get exluded from the result (e.g seen and disliked titles). */
	excludeIrrelevantTitles?: Maybe<Scalars['Boolean']>;
	/**
	 * If set to true, only keeping upcoming titles.
	 *
	 * Since they don't have offers, the 'packages' filter also changes its behavior: it can be used to get titles upcoming on certain packages.
	 */
	isUpcoming?: Maybe<Scalars['Boolean']>;
	/** Keep only the titles having an offer with the given presentation types. */
	presentationTypes?: Maybe<Array<PresentationType>>;
	/** Keep only the titles having an offer with the given monetization types. */
	monetizationTypes?: Maybe<Array<MonetizationType>>;
	/** Keep only the titles having an offer priced within the given range. */
	price?: Maybe<FloatFilter>;
	/** Keep only the titles having at least one of the given genres. Short names are expected (e.g. 'act' for Action). */
	genres?: Maybe<Array<Scalars['String']>>;
	/** Exclude the titles having at least one of the given genres. Short names are expected (e.g. 'act' for Action). */
	excludeGenres?: Maybe<Array<Scalars['String']>>;
	/** Keep only the titles having at least one of the given production countries. */
	productionCountries?: Maybe<Array<Scalars['Country']>>;
	/** Exclude the titles having at least one of the given production countries. */
	excludeProductionCountries?: Maybe<Array<Scalars['Country']>>;
	/** Keep only the titles having these object types. */
	objectTypes?: Maybe<Array<ObjectType>>;
	/** Keep only the titles having at least one of the given age certifications. Technical names are expected (e.g. 'PG-13' for PG-13). */
	ageCertifications?: Maybe<Array<Scalars['String']>>;
	/** Keep only the titles having this person ID in the credits. */
	personId?: Maybe<Scalars['ID']>;
	/** Keep only the titles having an IMDB score within the given range. */
	imdbScore?: Maybe<FloatFilter>;
	/** Keep only the titles having a number of IMDB votes within the given range. */
	imdbVotes?: Maybe<IntFilter>;
	/** Keep only the titles having a runtime within the given range. */
	runtime?: Maybe<IntFilter>;
	/** Keep only the titles having a release year within the given range. */
	releaseYear?: Maybe<IntFilter>;
	/** Keep only the offers created within the given range. */
	offerDateCreated?: Maybe<DateFilter>;
	/** Keep only the offers that had their price changed within the given range. */
	offerLastChangeDate?: Maybe<DateFilter>;
	/** Keep only the offer date of titles leaving soon. */
	availableToDate?: Maybe<DateFilter>;
};

/** A connection object for a title list. */
export type TitleListConnection = {
	__typename?: 'TitleListConnection';
	/** The total number of items. */
	totalCount: Scalars['Int'];
	/** The edges for each of the items. */
	edges?: Maybe<Array<TitleListEdge>>;
	/** Information for paginating this connection. */
	pageInfo: PageInfo;
};

/** An edge object for a title list node. */
export type TitleListEdge = {
	__typename?: 'TitleListEdge';
	/** A cursor used for pagination. */
	cursor: Scalars['String'];
	/** The subheading the node belongs to. */
	subheading?: Maybe<TitleListSubheading>;
	/** The node represented by this edge. */
	node: MovieOrShow;
};

/** An entry in a user title list. */
export type TitleListEntry = {
	__typename?: 'TitleListEntry';
	/** The parent generic title list. */
	genericTitleList: GenericTitleList;
	/** The time at which the entry was created. */
	createdAt: Scalars['Time'];
};

/** The content types supported by the watchlist queries. */
export enum TitleListObjectType {
	/** That's a movie. */
	Movie = 'MOVIE',
	/** That's a show. */
	Show = 'SHOW',
}

/** The field/info to order titles by. */
export enum TitleListSorting {
	/** Sorted by JW popularity score. */
	Popular = 'POPULAR',
	/** Sorted by JW trending score. */
	Trending = 'TRENDING',
	/** Sorted randomly, based on the provided randomSeed. */
	Random = 'RANDOM',
	/** Sorted by title. */
	Alphabetical = 'ALPHABETICAL',
	/** Sorted by release year. */
	ReleaseYear = 'RELEASE_YEAR',
	/** Sorted by TMDB popularity. */
	TmdbPopularity = 'TMDB_POPULARITY',
	/** Sorted by IMDB score. */
	ImdbScore = 'IMDB_SCORE',
	/** Sorted by runtime. */
	Runtime = 'RUNTIME',
	/** Could also be called 'BY_SUBHEADING'. Sorted by last list interaction. */
	Relevance = 'RELEVANCE',
	/** Sorted by last addition to the list. */
	LastAdded = 'LAST_ADDED',
}

/** A list of the possible subheadings being returned, depending on the list type. */
export type TitleListSubheading = WatchNextSubheading | CaughtUpSubheading;

/** The different subheadings possible on the edges of a title list. */
export enum TitleListSubheadingTechnicalName {
	/** The show is coming back (new episode or season). */
	Upcoming = 'UPCOMING',
	/** The show is not airing anymore. */
	Finished = 'FINISHED',
	/** The shows under this category have been partly seen already. */
	ContinueWatching = 'CONTINUE_WATCHING',
	/** The shows under this category haven't been started. */
	NotStarted = 'NOT_STARTED',
}

/** The different readable list types. */
export enum TitleListType {
	/** The list of our watchlisted and not fully seen titles. */
	WatchNext = 'WATCH_NEXT',
	/** The list of the titles we're done watching. */
	CaughtUp = 'CAUGHT_UP',
	/** The list showing the liked titles of the user. */
	Likelist = 'LIKELIST',
	/** The list showing the disliked titles of the user. */
	Dislikelist = 'DISLIKELIST',
}

/** A UserCentrics (GDPR consent manager) consent. */
export type UcConsent = {
	__typename?: 'UCConsent';
	/** The id of the UserCentrics resource. */
	id: Scalars['String'];
	/** Whether the user consented or not. */
	consent: Scalars['Boolean'];
};

/** Upcoming release data for a title. */
export type UpcomingRelease = {
	__typename?: 'UpcomingRelease';
	/** The package on which the title is being released. Null if unknown. */
	package?: Maybe<Package>;
	/** The release date. Null if we don't know. */
	releaseDate?: Maybe<Scalars['Date']>;
	/** The release date display instructions. */
	label: UpcomingReleaseLabel;
	/** The release type. */
	releaseType: ReleaseType;
	/** The number of days for the content to be available. */
	releaseCountDown?: Maybe<Scalars['Int']>;
};

/** Upcoming release data for a title. */
export type UpcomingReleaseReleaseCountDownArgs = {
	country: Scalars['Country'];
};

/** The information that we should display to the users. */
export enum UpcomingReleaseLabel {
	/** We know that it's upcoming but we don't know when yet. */
	ToBeAnnounced = 'TO_BE_ANNOUNCED',
	/** Will be released today. */
	Today = 'TODAY',
	/** Will be released tomorrow. */
	Tomorrow = 'TOMORROW',
	/** Will be released on this precise date. */
	Date = 'DATE',
	/** Will be released over the given month. */
	Month = 'MONTH',
	/** Will be released over the given spring. */
	Spring = 'SPRING',
	/** Will be released over the given summer. */
	Summer = 'SUMMER',
	/** Will be released over the given autumn. */
	Autumn = 'AUTUMN',
	/** Will be released over the given winter. */
	Winter = 'WINTER',
	/** Will be released over the given year. */
	Year = 'YEAR',
}

/** The settings we want to update. If a field is null/undefined, it is ignored and the setting remains unchanged. */
export type UpdateSettingsInput = {
	/** Indicates if the user has been onboarded before going to the Home. */
	tasteSurveyCompleted?: Maybe<Scalars['Boolean']>;
	/** Indicates the type of onboarding the user took before going to the Home. */
	tasteSurveyType?: Maybe<TasteSurveyType>;
	/** Indicates the Gefjon model that was used to recommend the onboarding titles. */
	tasteSurveyModelVersion?: Maybe<Scalars['String']>;
	/** Stores the tracking consent data. */
	jwConsents?: Maybe<JwConsentsInput>;
	/** Used to store the timeline specials hidden by the user. */
	hiddenTimelineSpecials?: Maybe<Array<Scalars['String']>>;
};

/** The payload response of a settings update. */
export type UpdateSettingsPayload = {
	__typename?: 'UpdateSettingsPayload';
	/** The new state of the settings. */
	settings: Settings;
	/** Returns the packages available in your country on your platform. */
	packages: Array<Package>;
};

/** The payload response of a settings update. */
export type UpdateSettingsPayloadPackagesArgs = {
	country: Scalars['Country'];
	platform: Platform;
	monetizationTypes?: Maybe<Array<MonetizationType>>;
	includeAddons?: Maybe<Scalars['Boolean']>;
	iosPackages?: Maybe<Scalars['Boolean']>;
	hasTitles?: Maybe<Scalars['Boolean']>;
	hasSport?: Maybe<Scalars['Boolean']>;
};

/** A URL. Defined by Content. */
export type Url = Node & {
	__typename?: 'Url';
	/** The global node ID. */
	id: Scalars['ID'];
	/** The locale of the URL. */
	locale: Scalars['String'];
	/** The type of the object linked behind the URL. */
	objectType: ObjectType;
	/** The node linked behind the URL. */
	node: Node;
	/**
	 * The full path of the URL.
	 *
	 * e.g. '/de/Film/Spider-Man-Far-from-Home'
	 */
	fullPath: Scalars['String'];
	/** The h1 text. */
	heading1?: Maybe<Scalars['String']>;
	/** The h2 text. */
	heading2?: Maybe<Scalars['String']>;
	/** The meta title for search engines. */
	metaTitle?: Maybe<Scalars['String']>;
	/** The meta description for search engines. */
	metaDescription?: Maybe<Scalars['String']>;
	/**
	 * The meta robots field for search engines.
	 *
	 * e.g. 'index,follow'
	 */
	metaRobots?: Maybe<Scalars['String']>;
	/** The meta keywords for search engines. */
	metaKeywords?: Maybe<Scalars['String']>;
	/** The href lang tags. They indicate the variants of the same content in the different locales. */
	hrefLangTags: Array<HrefLangTag>;
	/** A non typed json object allowing some hacks in the front-end. */
	htmlContent?: Maybe<Scalars['Json']>;
};

/** A URL. Defined by Content. */
export type UrlHrefLangTagsArgs = {
	locale?: Maybe<Scalars['String']>;
};

/** BI application names. */
export enum UserApplication {
	/** The webapp. */
	Webapp = 'WEBAPP',
	/** The iOS app. */
	Ios = 'IOS',
	/** The Android app. */
	Android = 'ANDROID',
	/** The webapp on TV. */
	Tvwebapp = 'TVWEBAPP',
	/** The Android TV app. */
	Androidtv = 'ANDROIDTV',
	/** The tvOS app. */
	Tvos = 'TVOS',
	/** The Fire TV app. */
	Firetv = 'FIRETV',
	/** The WebOS TV app. */
	Webos = 'WEBOS',
	/** The Tizen TV app. */
	Tizen = 'TIZEN',
	/** The Xbox TV app. */
	Xbox = 'XBOX',
}

/** The user statistics. */
export type UserStats = {
	__typename?: 'UserStats';
	/** Indicates the number of sessions that the user had for every platform. BI data. */
	sessionsPerPlatform: SessionsPerPlatform;
	/** Indicates the user status for every platform. BI data. */
	statusPerPlatform: StatusPerPlatform;
	/** Indicates which applications the user has been using. */
	applicationListTotal: Array<UserApplication>;
	/** Indicates which audiences the user is part of. */
	audiences: Array<Audience>;
	/** Indicates if the user used his title lists already. */
	knowsAboutTitleLists: Scalars['Boolean'];
};

/** BI status for users. */
export enum UserStatus {
	/** User having more than 6 days with a session per month. Definition may become outdated, please double check with BI. */
	PowerUser = 'POWER_USER',
	/** User having 2 to 5 days with a session per month. Definition may become outdated, please double check with BI. */
	FrequentUser = 'FREQUENT_USER',
	/** User having 1 day with a session per month. Definition may become outdated, please double check with BI. */
	InfrequentUser = 'INFREQUENT_USER',
}

/** A subheading of the watch next list. */
export type WatchNextSubheading = {
	__typename?: 'WatchNextSubheading';
	/** The unique id of the subheading. */
	technicalName: WatchNextSubheadingTechnicalName;
	/** The translatable of the subheading. */
	translatable: Scalars['String'];
};

/** The different subheadings possible on the edges of a watch next list. */
export enum WatchNextSubheadingTechnicalName {
	/** The shows under this category have been partly seen already. */
	ContinueWatching = 'CONTINUE_WATCHING',
	/** The shows under this category haven't been started. */
	NotStarted = 'NOT_STARTED',
}

/** This filter allows filtering of a list of offers. */
export type WatchNowOfferFilter = {
	/** Keep only the offers having the given packages. Short names are expected (e.g. 'nfx' for Netflix). */
	packages?: Maybe<Array<Scalars['String']>>;
	/** Exclude the offers having the given packages. Short names are expected (e.g. 'nfx' for Netflix). */
	excludePackages?: Maybe<Array<Scalars['String']>>;
	/** Keep only the offers having the given presentation types. */
	presentationTypes?: Maybe<Array<PresentationType>>;
	/**
	 * Keep only the offers having the given monetization types.
	 *
	 * In general, we set the default to only keep flatrate/free offers to make sure a Watch Now is "seamless".
	 */
	monetizationTypes?: Maybe<Array<MonetizationType>>;
	/**
	 * Keep only the offers that had their last price drop on that date.
	 *
	 * When used in the context of the NewTitles query, this filter is set by default to the date of the bucket. Null otherwise.
	 */
	lastChangeDate?: Maybe<Scalars['Date']>;
};

/** This filter allows filtering of a list of offers. */
export type WatchNowSportOfferFilter = {
	/** Keep only the offers having the given packages. Short names are expected (e.g. 'nfx' for Netflix). */
	packages?: Maybe<Array<Scalars['String']>>;
};

/** The payload response of the Stripe subscription cancelation. */
export type CancelStripeSubscriptionPayload = {
	__typename?: 'cancelStripeSubscriptionPayload';
	/** The result for the stripe subscription cancelation request. */
	isSubscriptionCanceled: Scalars['Boolean'];
};
